/* eslint-disable import/no-cycle */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-nested-ternary */
/**
 * © [2024] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect } from 'react';
import clsx from 'clsx';
import {
  useLocation,
  NavLink,
  Route,
  Link,
  withRouter,
} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Drawer from '@material-ui/core/Drawer';
import CssBaseline from '@material-ui/core/CssBaseline';
import List from '@material-ui/core/List';
import Avatar from 'react-avatar';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import PowerSettingsNewIcon from '@mui/icons-material/PowerSettingsNew';
import Collapse from '@material-ui/core/Collapse';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import Routes from './Routes';
import Hamburger from './hamburger';
import Footer from '../Layout/footer';
import Orange from './orange';
import { icons } from './navStructure';
import ErrorHandler from '../ErrorHandler';
import * as AppConstants from '../AppConstants';
import SVGComponent from '../SVGComponents/SVGComponents';
import {
  openHelpModuleUrl,
  openReleaseNotesUrl,
  safeWindowOpen,
} from '../CommonUtilities/safeWindowOpen';
import {
  getUserDefaults,
  dispatchTabChanges,
  clearReduxUserDefaultScreen,
} from '../../Modules/System/UserDefault/store/actions';

import {
  clearReduxMaintainCheckSearchScreen,
  clearReduxMaintainCheckDetailScreen,
} from '../../Modules/Maintain/Check/store/actions';
import {
  clearReduxFirstScreenUnitConversion,
  clearReduxDetailScreenUnitConversion,
} from '../../Modules/Maintain/unitConversion/store/actions';
import { clearPreloadedData } from '../../Modules/Tasks/RequestClaimAudit/store/action';
import * as NavigationConstants from './navigationConstants';
import SaveCancelPopup from '../CustomSaveCancelPopup/SaveCancelPopup';
import {
  clearReduxManufacturerSecondScreen,
  setSearchManufacturerTab,
  cancelProviderApiRequest,
} from '../../Modules/Maintain/Manufacturer/store/ManufacturerAction';
import { resetStore } from '../../Modules/Tasks/AssignDisputesSearch/store/action';
import { clearAssignDetlReduxStore } from '../../Modules/Tasks/AssignDisputesDetail/store/actions';
import { clearReqAccRecSearchPage } from '../../Modules/Research/AccountReceivable/ReqAccReceivable/store/actions';
import { resetARSummaryByMfgData } from '../../Modules/Research/AccountReceivable/ARSummaryByMfg/store/actions';
import { clearARSummaryByQtrPage } from '../../Modules/Research/AccountReceivable/ARSummaryByQtr/store/actions';
import { clearMfgAccountRecPage } from '../../Modules/Research/AccountReceivable/MfgAccountsRec/store/actions';
import { clearAccountRecNDCDetailPage } from '../../Modules/Research/AccountReceivable/AccRecNDCDetail/store/actions';
import { clearAccountRecNDCActivityPage } from '../../Modules/Research/AccountReceivable/AccRecNDCActivity/store/actions';
import { clearQtrAccountRecPage } from '../../Modules/Research/AccountReceivable/QtrAccountsRec/store/actions';
import { clearARManufacturerPage } from '../../Modules/Research/AccountReceivable/ARManufacturer/store/actions';
import { resetARSummaryByMfgAllData } from '../../Modules/Research/AccountReceivable/ARSummaryByMfgAll/store/actions';
import { clearARSummaryByQtrAllPage } from '../../Modules/Research/AccountReceivable/ARSummaryByQtrAll/store/actions';
import { clearAccRecNDCDetailAllPage } from '../../Modules/Research/AccountReceivable/AccRecNDCDetailAll/store/actions';
import { clearQtrAccountRecAllPage } from '../../Modules/Research/AccountReceivable/QtrAccountsRecAll/store/actions';
import { dispatchClearTBillReduxStore } from '../../Modules/Maintain/tBillRates/store/actions';
import { clearExcludedNDCsPage } from '../../Modules/Maintain/excludedNDCs/store/actions';
import {
  removeLetterTemplateErrorMsgList,
  setRemoveLetterTemplateExtraState,
  clearLetterTemplatePage,
} from '../../Modules/Maintain/LetterTemplate/store/actions';
import { clearCreateLetterPage } from '../../Modules/Tasks/CreateLetter/store/action';
import {
  resetReduxDL,
  clearDisplayLetterPage,
} from '../../Modules/Display/Letter/store/Actions';
import { clearGenerateCollectionLetterPage } from '../../Modules/Tasks/GenerateCollectionLetter/store/actions';
import { clearReduxSuspendedCheckScreen } from '../../Modules/Research/SuspendedChecks/store/Actions';
import { clearReduxLogCheckScreen } from '../../Modules/Tasks/LogCheck/store/Actions';
import { clearReduxForSystemLevelCommCorrespondence } from '../../Modules/System/commentsAndCorrespondence/store/Actions';
import {
  clearReduxForCmsRosiDetailsScrren,
  clearReduxForCmsRosiSearchScrren,
} from '../../Modules/Research/CMSROSI/store/Actions';
import {
  setContactAnomaliesTab,
  dispatchInputValue,
  clearReduxContactAnomaliesScreen,
} from '../../Modules/Research/ContactAnomalies/store/Actions';
import {
  clearReduxForInvoiceAuditDetailScreen,
  clearReduxForInvoiceAuditSearchScreen,
} from '../../Modules/Research/InvoiceAudits/store/Actions';
import { clearReduxForChecksByInvoices } from '../../Modules/Tasks/CheckByInvoices/store/actions';
import { resetReduxStore } from '../../Modules/contactType/store/actions';
import {
  resetStoreDrugFamily,
  clearReduxDrugFamilyScreen,
} from '../../Modules/Maintain/DrugFamily/DrugFamilySearch/store/actions';
import { clearReduxDrugFamilyDetailScreen } from '../../Modules/Maintain/DrugFamily/DrugFamilyDetails/store/actions';
import {
  searchMailingRequestAction,
  handleHeaderErrorMessages,
  handleFieldLevelErrMsg,
  dispatchAllManufacturerRequestMailing,
  clearReduxMailingRequest,
} from '../../Modules/Tasks/MailingLabelRequest/store/actions';
import {
  dispatchTabValue,
  clearReduxForLabelerDifferenceScreen,
} from '../../Modules/Research/LabelerDifferences/store/actions';
import {
  clearReduxDisplayCheckDetailScreen,
  setIsSearchCheckFromDisplay,
} from '../../Modules/Display/Check/store/action';
import {
  clearReduxForCmsMissMatchSearchScrren as clearReduxForCmsMissMatchSearchScreen,
  clearReduxForCmsMissMatchDetailScrren as clearReduxForCmsMissMatchDetailScreen,
} from '../../Modules/Research/CMSMismatch/store/actions';
import { clearReduxforCalculateInterestSearch } from '../../Modules/Tasks/CalculateInterest/store/Actions';
import { clearReduxforLinkNewDrugsToDrugFamily } from '../../Modules/Tasks/LinkNewDrugsToDrugFamily/store/action';
import {
  clearReduxMaintainContractSearchScreen,
  clearReduxMaintainContractDetailScreen,
} from '../../Modules/Maintain/Contract/store/actions';
import {
  setPlanTabData,
  saveContactData,
  clearReduxForMaintainPlanScreen,
  setReduxDataSearchScreen,
} from '../../Modules/Maintain/Plan/store/actions';
import {
  clearReduxForMaintainGroupScreen,
  setGroupTabDataAction,
  setSelectedClientAction,
} from '../../Modules/Maintain/group/store/group-action';
import {
  clearReduxForDisputeDetailScreen,
  clearReduxForNdcDisputeDetailScreen,
} from '../../Modules/Research/Disputes/store/actions';
import {
  clearReduxForRosiInconsistencies,
  clearReduxForRosiInconsistenciesDetail,
} from '../../Modules/Research/CMSRPInconsistencies/store/actions';
import {
  dispatchClaimAuditDetailTabData,
  dispatchClaimAuditDetails,
  dispatchPageCountwithDetails,
  clearReduxForClaimAuditSelectScreen,
  setChangesDataList,
} from '../../Modules/Research/ClaimAudits/store/actions';
import {
  clearCmsDrugFileDiscrepancies,
  resetRedux,
} from '../../Modules/Research/CMSDrugFileDiscrepancies/store/Actions';
import {
  clearReduxUnderThresholdInvDetailScreen,
  clearReduxUnderThresholdInvSearchScreen,
} from '../../Modules/Research/UnderThresholdInvoices/store/Actions';
import {
  setGenerateInvoiceSearchTab,
  handleErrorMesGenerateInvInRedux,
  dispatchQuarterData,
  dispatchPlanTypeFilterData,
  dispatchGenerateInvoiceCriteriaList,
  setGenerateInvoiceDetailTab,
  setPervSearchScreenTabDataRedux,
  dispatchGetPlanTypeCd,
  setPdfInvoice,
  clearReduxForGenerateSearchScreen,
  clearReduxForGenerateDetailScreen,
} from '../../Modules/Invoice/GenerateInvoice/store/Actions';
import {
  storePriceLevelErrors,
  storePriceLevelSearchData,
  storeUpdatedPage,
  storePriceDetailErrors,
} from '../../Modules/Maintain/RebatePriceLevel/store/actions';
import {
  dispatchGetCommonData,
  dispatchGetProvider,
  dispatchGetProviderDropDown,
  dispatchGetDetailData,
  dispatchReviewProblemDropdown,
  dispatchReviewCorrectionDropdown,
  setSelectTableData,
  dispatchNdcGridDetail,
  dispatchProviderReviewClaimHeader,
  dispatchProviderFrozenComplete,
  dispatchProblemCode,
  dispatchcorrectionCode,
  dispatchBottonState,
  handleErrorMessages,
} from '../../Modules/Tasks/ProviderReview/Store/actions';
import { generateQuarter } from '../../Modules/Maintain/RebatePriceLevel/Components/utils';
import {
  dispatchMaintanancePriceDetails,
  storeUpdatedDetailsPage,
  storePriceSearchInputData,
  dispatchManufacturerList,
  dispatchAllDrugFamilies,
  storePriceDetailsErrors,
  onChangePage,
  dispatchMaintanancePriceGridDetails,
  clearReduxforRebatePriceDetails,
  clearReduxforRebatePriceSearch,
} from '../../Modules/Maintain/RebatePriceDetails/store/actions';
import {
  clearReduxAllocatePaymentFirstScreen,
  clearReduxAllocatePaymentSecondScreen,
  clearReduxAllocatePaymentThirdScreen,
} from '../../Modules/Tasks/AllocatePayments/store/Actions';
import routeHelpTabConfig from './HelperTab';
import { clearQtrlyPayTab } from '../../Modules/Reports/QuarterlyPayment/store/actions';
import {
  refreshInvQtrnotPaidTab,
  refreshInvQtrnotPaidTabDisplay,
} from '../../Modules/Reports/InvoicesQtrnitPaid/store/action';
import {
  refreshDisputeAmount,
  refreshDisputeAmountDisplay,
} from '../../Modules/Reports/DisputeAmmount/Store/actions';
import {
  refreshQuarterlyPayment,
  refreshQuarterlyPaymentDisplay,
} from '../../Modules/Reports/QuarterlyPayments/Store/actions';
import {
  refreshPaymentSummary,
  refreshPaymentSummaryDisplay,
} from '../../Modules/Reports/PaymentSummary/Store/action';
import {
  refreshDisputeActivity,
  refreshDisputeActivityDisplay,
} from '../../Modules/Reports/DisputeActivity/Store/action';
import {
  refreshCurrentToPrevious,
  refreshCurrentToPreviousDisplay,
} from '../../Modules/Reports/CurrentToPreviousQuarter/Store/action';
import {
  refreshUnallocatedBalance,
  refreshUnallocatedBalanceDispaly,
} from '../../Modules/Reports/UnallocatedReports/store/action';
import { clearCreateCmsTab } from '../../Modules/System/TechnicalWindow/OnlineFixes/ReqInitCorrectCmsReport/Store/actions';
import {
  refreshInterestOverride,
  refreshInterestOverrideDisplay,
} from '../../Modules/Reports/InerestOverride/Store/actions';
import {
  clearReduxDataOnCheckAllocationComparisonDetailScr,
  clearReduxDataOnCheckAllocationComparisonSearchScr,
  refreshCheckAllocationComparision,
} from '../../Modules/Reports/CheckAllocationComparison/Store/actions';
import {
  clearReduxInterestRecievedDetailsScreen,
  clearReduxInterestRecievedSearchScreen,
  refreshInterestRecieved,
} from '../../Modules/Reports/InterestRecieved/Store/actions';
import {
  refreshCMSDrug,
  refreshCMSDrugDisplay,
} from '../../Modules/Reports/CmsDrug/Store/action';
import { clearReduxViewCheckAllocateScreen } from '../../Modules/Tasks/ViewCheckAllocation/store/actions';

import {
  dispatchCurrentDisputesErr,
  dispatchErrorMsgPerformDis,
  dispatchManufacturerValue,
  dispatchPerformDisputeClearRedux,
  dispatchPerformDisputeResolutionObj,
} from '../../Modules/Tasks/PerformDisputeResolutions/store/actions';
import {
  refreshPreInvoiceUnitAdujustment,
  refreshPreInvoiceUnitAdujustmentDisplay,
} from '../../Modules/Reports/PreInvoiceUnitAdjustment/Store/action';
import {
  refreshNDCDetails,
  refreshNDCDetailsDisplay,
} from '../../Modules/Reports/NDCDetails/Store/actions';
import {
  refreshNDCHistory,
  refreshNDCHistoryDisplay,
} from '../../Modules/Reports/NDCHistory/Store/actions';
import { refreshNDCDetailsAdjusted } from '../../Modules/Reports/AdjustedClaims/Store/action';
import {
  refreshProgramCategory,
  refreshProgramCategoryDisplay,
} from '../../Modules/Reports/ProgramAndEligibility/Store/action';
import {
  refreshActiveLabeler,
  refreshActiveLabelerDisplay,
} from '../../Modules/Reports/ActiveLabeler/Store/action';
import {
  refreshCmsAdjustment,
  refreshCmsAdjustmentDisplay,
} from '../../Modules/Reports/CmsReportAdjustment/Store/action';
import {
  refreshTopBalances,
  refreshTopBalancesDisplay,
} from '../../Modules/Reports/TopBalances/Store/action';
import { refreshTotalDollarsPaid } from '../../Modules/Reports/TotalDollersPaid/Store/actions';
import {
  refreshAdjustmentCodeByReason,
  refreshReduxAdjustmentByReasonDetailScreen,
} from '../../Modules/Reports/AdjustmentByReasonCode/Store/actions';
import {
  refreshTerminatedLabeler,
  refreshTerminatedLabelerDisplay,
} from '../../Modules/Reports/TerminatedLabeler/Store/actions';
import {
  refreshSupplementalRates,
  refreshSupplementalRatesDisplay,
} from '../../Modules/Reports/SupplementalRates/Store/action';
import {
  refreshChipCshcnRates,
  refreshChipCshcnRatesDisplay,
} from '../../Modules/Reports/ChipCshcnRates/Store/actions';
import {
  refreshSubstanceAbuse,
  refreshSubstanceAbuseDisplay,
} from '../../Modules/Reports/SubstanceAbuse/Store/action';
import {
  refreshMfgOustandingBalance,
  refreshMfgOustandingBalanceDisplay,
} from '../../Modules/Reports/ManufacturerOutstandingBalance/Store/Actions';
import {
  refreshDProviderClaim,
  refreshDProviderClaimDisplay,
} from '../../Modules/Reports/DProviderClaim/Store/action';
import { ALLOCATE_PAYMENT_DETAIL_SCREEN_URL } from '../CommonConstants/commonConstants';
import {
  refreshChipCshcnRateAudit,
  refreshChipCshcnRateAuditDisplay,
} from '../../Modules/Reports/ChipCshcnRateAudit/Store/actions';
import {
  clearReduxZeroURADetailsScreen,
  clearReduxZeroURASearchScreen,
  refreshZeroURA,
  refreshZeroURADisplay,
} from '../../Modules/Reports/ZeroURA/Store/action';
import {
  dispatchDisplayUnitAdjustment,
  refreshUnitAdjustment,
} from '../../Modules/Reports/UnitAdjustmentatNDCLevel/Store/action';
import { refreshQuarterlyClaimReconcilliationSate } from '../../Modules/Reports/QuarterlyClaimsReconcilliation/Store/actions';
import SessionExpire from '../Dialog/SessionExpireDialog';
import {
  refreshDrugsTherapeuticClass,
  refreshDisplayDrugsTherapeuticClass,
} from '../../Modules/Reports/DrugsTherapeuticClass/Store/Actions';
import {
  refreshHCPCScodeClaims,
  refreshHCPCScodeClaimsDisplay,
} from '../../Modules/Reports/HcpcsCodeClaimsPaid/Store/Action';
import {
  refreshFamilyPlanningDrugInv,
  refreshFamilyPlanningDrugInvDisplay,
} from '../../Modules/Reports/FamilyPlanningDrugsInvoicedforRebates/Store/Actions';
import {
  refreshFamilyPlanningDrugPmtRec,
  refreshFamilyPlanningDrugPmtRecDisplay,
} from '../../Modules/Reports/FamilyPlanningDrugsPaymentReceived/Store/Actions';
import {
  refreshOustandingByLabelerAndQtr,
  refreshOustandingByLabelerAndQtrDisplay,
} from '../../Modules/Reports/OutstandingBalanceByLabererAndQuarter/Store/Action';
import { refreshMonthlyClaimReconcilliationState } from '../../Modules/Reports/MonthlyClaimsReconcilliation/Store/actions';
import {
  clearReduxOutStandingDisputesForNumberOfDaysDetailsScreen,
  clearReduxOutStandingDisputesForNumberOfDaysSearchScreen,
} from '../../Modules/Reports/OutstandingDisputesForNumOfDays/Store/actions';
import {
  clearReduxDataOnCMSQtrReport,
  refreshCMSQuarterlyReporting,
  refreshCMSQuarterlyReportingDisplay,
} from '../../Modules/CMS/CMSQuarterlyReporting/Store/action';
import {
  refreshRebatePercent,
  refreshRebatePercentDisplay,
} from '../../Modules/Reports/RebatePercentOfSpend/Store/action';
import { resetRequestCGPStore } from '../../Modules/System/claimGroupingParameter/store/actions';
import {
  resetURADetailStore,
  resetURASearchStore,
} from '../../Modules/Display/URASearch/store/actions';
import {
  refreshDisputeCode,
  refreshDisputeCodeDisplay,
} from '../../Modules/Reports/DisputeCodes/Store/action';
import {
  refreshDisputeRecap,
  refreshDisputeRecapDisplay,
} from '../../Modules/Reports/DisputeRecapitulation/Store/action';
import {
  refreshBProviderClaims,
  refreshBProviderClaimsDisplay,
} from '../../Modules/Reports/ProviderClaim/Store/action';
import {
  refreshDrugType,
  refreshDrugTypeDisplay,
} from '../../Modules/Reports/DrugTypeSummary/store/action';
import {
  refreshCMSUroa,
  refreshCMSUroaDisplay,
} from '../../Modules/Reports/CmsUroa/Store/action';
import { refreshRebateSummary } from '../../Modules/Reports/summaryReports/store/action';
import {
  refreshMcoClaims,
  refreshMcoClaimsDisplay,
} from '../../Modules/Reports/MCOClaims/Store/Actions';
import {
  refreshRosiPqas,
  refreshRosiPqasDisplay,
} from '../../Modules/Reports/RosiPqas/Store/action';
import {
  refreshCurrentZeroURA,
  refreshCurrentZeroURADisplay,
} from '../../Modules/Reports/CurrentZeroURA/Store/action';
import {
  refreshCashReceiptSummary,
  refreshCashReceiptSummaryDisplay,
} from '../../Modules/Reports/CashReceiptSummary/Store/actions';
import {
  refreshNDCPayment,
  refreshNDCPaymentDisplay,
} from '../../Modules/Reports/NDCPayment/Store/actions';
import {
  refreshInstitutionalClaimUnitTypeDiscDetailScreen,
  refreshInstitutionalClaimUnitTypeDiscrepancy,
} from '../../Modules/Reports/InstitutionalClaimUnitTypeDiscrepancy/Store/actions';
import {
  refreshRider,
  refreshRiderDisplay,
} from '../../Modules/Reports/Rider/Store/actions';
import {
  clearReduxOutStandingDisputesQuarterOfDaysDetailsScreen,
  clearReduxOutStandingDisputesQuarterOfDaysSearchScreen,
} from '../../Modules/Reports/OutstandingDisputesForQuarter/Store/actions';
import {
  clearReduxExcludedClaimsDetailsScreen,
  clearReduxExcludedClaimsSearchScreen,
  refreshExcludedClaims,
} from '../../Modules/Reports/ExcludedClaims/Store/actions';
import { FAIL_PROCESSING_REQUEST } from '../Errors/constantMessageData';
import {
  refresgManufacturerSummary,
  refresgManufacturerSummaryDisplay,
} from '../../Modules/Reports/ManufacturerSummary/Store/actions';
import {
  refreshInvoiceRegister,
  refreshInvoiceRegisterDisplay,
} from '../../Modules/Reports/InvoiceRegister/Store/action';
import {
  clearReduxForLogBatchFirstScreen,
  clearReduxForLogBatchSecondScreen,
} from '../../Modules/Tasks/LogBatchTotal/store/actions';
import { clearReduxSearchRbt } from '../../Modules/Maintain/RebateProgram/SearchRebate/store/actions';
import { clearMaintainRbtRedux } from '../../Modules/Maintain/RebateProgram/MaintainRebate/store/actions';
import { clearCreateRbtRedux } from '../../Modules/Maintain/RebateProgram/CreateRebate/store/actions';
import { clearReduxForFilterAndSort } from '../Table/store/Actions';
import { clearReduxEventLoggingScreen } from '../../Modules/System/EventLogging/store/actions';
import { clearReduxUpdateGeneralParamScreen } from '../../Modules/System/UpdateParamGeneral/store/action';
import {
  clearReduxDisplayInvoiceDetailScreen,
  clearReduxDisplayInvoiceSearchScreen,
} from '../../Modules/Display/invoice/store/actions';
import { clearReduxReminderRecipientsScreen } from '../../Modules/System/ReminderRecipients/store/Actions';
import { clearReduxUserListScreen } from '../../Modules/System/UserList/Store/actions';
import { clearReduxCodeTablesScreen } from '../../Modules/System/codeTables/store/actions';
import { clearReduxPriceTypeScreen } from '../../Modules/System/priceType/store/action';
import {
  clearReduxProduceResultDetailScreen,
  clearReduxProduceResultSearchScreen,
} from '../../Modules/System/ProcedureResult/store/actions';
import { clearReduxNumberOfUnitSearchScreen } from '../../Modules/Maintain/NumberOfUnits/store/action';
import { clearReduxSystemReminderScreen } from '../../Modules/System/SystemReminder/store/Actions';
import { refreshContractReport } from '../../Modules/Reports/Contract/Store/actions';
import {
  clearReduxProviderDetailScreen,
  clearReduxProviderSearchScreen,
} from '../../Modules/Display/Provider/store/action';
import {
  resetNDCData,
  resetNDCDetailsData,
} from '../../Modules/Display/NDC/store/action';
import { clearReduxForClaimSearchScreen } from '../../Modules/Display/Claim/store/action';
import { clearReduxForInvoiceReportScreen } from '../../Modules/Display/InvoiceReport/store/actions';
import { ClearReduxDataIneligibleProviderScr } from '../../Modules/Maintain/IneligibleProviders/Store/actions';
import {
  clearReduxForMaintainClientScreen,
  setReduxDataIntoSearchScr,
} from '../../Modules/Maintain/client/store/actions';
import { resetMatDrugStore } from '../../Modules/CMS/MaintainMATDrug/store/actions';
import { resetRequestDurgPriceLoadStore } from '../../Modules/Invoice/RequestDrugPriceLoad/store/action';
import { resetRequestInvoiceCalculationStore } from '../../Modules/Invoice/RequestInvoiceCalculation/Store/actions';
import { resetReqURLCalcStore } from '../../Modules/Invoice/RequestURACalculation/Store/actions';
import CommonModal from '../Dialog/CommonModal';
import { clearReduxReqDataNicheReportScreen } from '../../Modules/Tasks/RequestDataNicheReport/Store/Actions';
import { resetIneligibleCPTStore } from '../../Modules/Maintain/MaintainIneligibleCPT/Store/Actions';
import { clearReduxCalculatedInterest } from '../../Modules/Display/CalculatedInterest/store/actions';
import { clearReduxDisplayClaim } from '../../Modules/Display/Claim/store/action';
import { clearReduxInvoiceQtr } from '../../Modules/Reports/InvoicesQtrnitPaid/store/action';
import { dispatchFlag } from '../../Modules/CMS/CMSQuarterlyReporting/Store/action';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    height: '100%',
    padding: '20px 0 0 0',
  },
  drawer: {
    boxSizing: 'border-box',
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    position: 'relative',
    boxSizing: 'border-box',
    width: drawerWidth,
  },
  drawerPaperShrink: {
    position: 'relative',
    boxSizing: 'border-box',
    width: 100,
  },
  drawerFooter: {
    display: 'flex',
    marginTop: 'auto',
    width: '100%',
    alignItems: 'center',
    ...theme.mixins.toolbar,
    justifyContent: 'center',
  },
  drawerFooterText: {
    color: '#000',
    fontSize: '10px !important',
    marginBottom: ' 0px',
    letterDpacing: '-0.4px',
    fontWeight: '600',
  },
  loginStatus: {
    display: 'flex',
    alignItems: 'center',
  },
  dropDownItem: {
    padding: '10px 24px',
  },
  nestedFolder: {
    paddingRight: '16px!important',
  },
}));

const Item = ({
  navTo,
  value,
  isFormDirty,
  isFormError,
  isFormSave,
  isRefresh,
  icon = null,
  hasChildren = false,
  isSelected = true,
  toggleDrawer,
  drawerIsOpen,
  dispatch,
}) => {
  const HamburgerIcon = () => (
    <Hamburger isOpen={drawerIsOpen} toggleDrawer={toggleDrawer} />
  );
  const openInNewTab =
    value === 'MARS' ||
    value === 'FADS' ||
    value === 'Operational Insights' ||
    value === 'Performance Insights' ||
    value === 'Claims';

  if ((!hasChildren || value === 'CMdS-Rebates') && !openInNewTab) {
    return (
      <>
        {value === 'Dashboard' && <HamburgerIcon />}
        <NavLink
          classes={isSelected ? 'side-menu-with-active' : ''}
          style={{ display: 'inline-flex' }}
          to={navTo}
          onClick={() => {
            if (window.screen.width <= 991) {
              //setDrawerOpen(false)
              toggleDrawer();
              toggleDrawer();
            }
            if (navTo === '/checks') {
              const updateTabs =
                JSON.parse(localStorage.getItem('tabItemsData')) == null
                  ? []
                  : JSON.parse(localStorage.getItem('tabItemsData'));

              if (
                updateTabs.findIndex((item) => item.navTo === '/check') !== -1
              ) {
                dispatch(clearReduxMaintainCheckSearchScreen());
                const filterArr = updateTabs.filter(
                  (item) => item.navTo !== '/check'
                );
                localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
              }

              dispatch(setIsSearchCheckFromDisplay(true));
            } else if (navTo === '/check') {
              const updateTabs =
                JSON.parse(localStorage.getItem('tabItemsData')) == null
                  ? []
                  : JSON.parse(localStorage.getItem('tabItemsData'));

              if (
                updateTabs.findIndex((item) => item.navTo === '/checks') !== -1
              ) {
                dispatch(clearReduxMaintainCheckSearchScreen());
                const filterArr = updateTabs.filter(
                  (item) => item.navTo !== '/checks'
                );
                localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
              }
              dispatch(setIsSearchCheckFromDisplay(false));
            }
            const tabItemsData =
              JSON.parse(localStorage.getItem('tabItemsData')) == null
                ? []
                : JSON.parse(localStorage.getItem('tabItemsData'));
            const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
            const isAlreadyAvailable = tabItemsData.findIndex(
              (item) => item.navTo === navTo
            );
            if (isAlreadyAvailable === -1) {
              tabItemsData.push({
                navTo: navTo,
                value: value,
                isFormDirty: isFormDirty,
                isFormSave: isFormSave,
                isFormError: isFormError,
                isRefresh: isRefresh,
              });

              if (
                updateTabs &&
                updateTabs.filter((x) => {
                  return x.navTo !== navTo;
                }).length > 0
              ) {
                tabItemsData
                  .filter((x) => {
                    return x.navTo !== navTo;
                  })
                  .map((item) => {
                    item.isFormDirty = updateTabs.filter((x) => {
                      return x.navTo === item.navTo;
                    })[0].isFormDirty;
                    item.isFormSave = updateTabs.filter((x) => {
                      return x.navTo === item.navTo;
                    })[0].isFormSave;
                    item.isFormError = updateTabs.filter((x) => {
                      return x.navTo === item.navTo;
                    })[0].isFormError;
                    return item;
                  });
              }
            }
            if (navTo === '/check') {
              const filterArr = tabItemsData.filter(
                (item) => item.navTo !== '/searchViewCheckAllocation'
              );
              localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
              dispatch(clearReduxMaintainCheckSearchScreen());
            } else if (navTo === '/searchViewCheckAllocation') {
              const filterArr = tabItemsData.filter(
                (item) => item.navTo !== '/check'
              );
              localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
              dispatch(clearReduxMaintainCheckSearchScreen());
            } else {
              localStorage.setItem(
                'tabItemsData',
                JSON.stringify(tabItemsData)
              );
            }

            if (value === 'Dashboard') {
              if (document.getElementById('iframe')) {
                document.getElementById('iframe').classList.add('hide');
              }
              if (document.getElementById('tableDisplay')) {
                document
                  .getElementById('tableDisplay')
                  .classList.remove('hide');
              }
              if (document.getElementById('sidebar-div')) {
                document.getElementById('sidebar-div').classList.remove('hide');
              }
              if (document.getElementById('alert-div')) {
                document.getElementById('alert-div').classList.remove('hide');
              }
              if (document.getElementById('main-col')) {
                document
                  .getElementById('main-col')
                  .classList.remove('col-lg-12');
              }
              if (document.getElementById('dashboard-heading')) {
                document
                  .getElementById('dashboard-heading')
                  .classList.remove('hide');
              }
              if (document.getElementById('banner-section')) {
                document
                  .getElementById('banner-section')
                  .classList.remove('hide');
              }
            } else if (value === 'Release Notes') {
              localStorage.setItem('tabItemsData', JSON.stringify([]));
              openReleaseNotesUrl();
            } else if (value === 'Help Index') {
              localStorage.setItem('tabItemsData', JSON.stringify([]));
              openHelpModuleUrl('Default.htm');
            }
          }}
        >
          {icon && icon}
          <ListItemText primary={value} />
          {hasChildren ? isSelected ? <ExpandLess /> : <ExpandMore /> : null}
        </NavLink>
      </>
    );
  }
  if (!hasChildren && openInNewTab) {
    return (
      <>
        <a
          classes={isSelected ? 'side-menu-with-active' : ''}
          style={{ display: 'inline-flex', width: '100%', height: '100%' }}
          href={navTo}
          target="_blank"
        >
          {icon && icon}
          <ListItemText primary={value} onClick={() => {}} />
          {hasChildren ? isSelected ? <ExpandLess /> : <ExpandMore /> : null}
        </a>
      </>
    );
  }
  return (
    <>
      {icon && icon}
      <ListItemText
        primary={value}
        onClick={() => {
          openInNewTab && safeWindowOpen(navTo);
        }}
      />
      {hasChildren ? isSelected ? <ExpandLess /> : <ExpandMore /> : null}
    </>
  );
};

/* class Menu extends React.Component {
  state = {
    selectedItems: [],
  };

  selectActive = (id, nestLvl, isFolder) => {
    const _selectedItems = [...this.state.selectedItems];
    _selectedItems[nestLvl] !== id
      ? (_selectedItems[nestLvl] = id)
      : isFolder && _selectedItems.splice(nestLvl);
    _selectedItems.length > nestLvl && _selectedItems.splice(nestLvl + 1);
    this.setState({ selectedItems: _selectedItems });
  };

  rerenderActive(path) {
    const _selectedItems = getActivePath(path);
    this.setState({ selectedItems: _selectedItems || [] });
  }

  componentDidMount() {
    this.rerenderActive(this.props.location.pathname);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.rerenderActive(this.props.location.pathname);
    }
  }

  renderSubMenu({ menuItems, nestedLevel = 0 }) {
    const MenuItems = menuItems.map((structure, i) => {
      const {
        classes,
        drawerIsOpen,
        toggleDrawer,
        userPrivilegesList,
        userInquiry,
      } = this.props;
      const newNestedLevel = nestedLevel + 1;
      const isSelected = this.state.selectedItems[nestedLevel] === structure.id;
      const Item_1 = Item({
        ...structure,
        nestedLevel,
        isSelected,
        ...this.props,
      });
      const SubMenu = structure.hasChildren
        ? this.renderSubMenu({
            menuItems: structure.children,
            nestedLevel: newNestedLevel,
          })
        : null;
      const colorLvl = nestedLevel === 0 ? 1 : 1 + nestedLevel * 0.2;
      return (
        <React.Fragment key={structure.id}>
          <ListItem
            button
            key={structure.value}
            className={clsx(
              classes.nestedFolder,
              isSelected ? 'highlighted-side-nav' : ''
            )}
            id={structure.id}
            style={{
              ...(isSelected
                ? {
                    background: `rgb(${39 * colorLvl},${68 * colorLvl},${
                      99 * colorLvl
                    })`,
                  }
                : {}),
            }}
            onClick={() => {
              !drawerIsOpen && toggleDrawer();
              this.selectActive(
                structure.id,
                nestedLevel,
                structure.hasChildren
              );
              !structure.hasChildren &&
                this.rerenderActive(this.props.location.pathname);
            }}
          >
            {Item_1}
          </ListItem>
          <Collapse
            style={{ paddingLeft: 16 + nestedLevel * 8 }}
            in={isSelected && drawerIsOpen}
          >
            {SubMenu}
          </Collapse>
        </React.Fragment>
      );
    });

    return MenuItems;
  }

  render() {
    return (
      <List className='side-menu-list'>
        {this.renderSubMenu({ menuItems: this.props.menuItems })}
      </List>
    );
  }
} */

export const DrawerFooter = ({ print }) => {
  const classes = useStyles();
  return (
    <div className={classes.drawerFooter}>
      <p className={clsx(classes.drawerFooterText, '')}>Powered By</p>
      <img
        src="/bottom_logo.png"
        alt="conduent logo"
        style={{
          width: '50%',
          minWidth: print ? 100 : 0,
          maxWidth: print ? 100 : 200,
        }}
      />
    </div>
  );
};

function App(props) {
  const $ = require('jquery');
  const getHelpUrl = useLocation();
  const classes = useStyles();
  const [drawerIsOpen, setDrawerOpen] = React.useState(true);
  const [openClose, setOpenClose] = React.useState(false);
  const [mainClass, setMainClass] = React.useState('');
  const [activeTabValue, setActiveTabValue] = React.useState('');
  const [openCnf, setOpenCnf] = React.useState(false);

  const [menuState, setMenuState] = React.useState({});
  const [menuItems, setMenuItems] = React.useState([]);
  const [menuActiveState, setMenuActiveState] = React.useState({});
  const [menuElementActive, setMenuElementActive] = React.useState({});
  const dispatch = useDispatch();
  const logInUserID = useSelector((state) => state.sharedState.logInUserID);
  const generalSystemParameterDetails = useSelector((state) => {
    return state.sharedState.SystemProviderReducer?.generalSystemParameter
      ?.paramGeneralVO;
  });
  const [timedOutMsg, setTimedOutMsg] = React.useState(null);
  const getUserDefaultValues = (value) => dispatch(getUserDefaults(value));

  // const loginState = JSON.parse(localStorage.getItem('loginState'));
  const loginState = useSelector(
    (state) => state?.sharedState?.SharedReducer?.loginStateStoreObj
  );

  useEffect(() => {
    if (!loginState?.menuItems) return;
    const batchInd = parseInt(
      generalSystemParameterDetails?.[0]?.checkLogUsesBatchInd,
      10
    );
    let updatedMenu = [];
    if (batchInd === 0) {
      updatedMenu = loginState.menuItems.map((item) => {
        const newItem = { ...item, children: [...(item.children || [])] };

        if (newItem.name === 'Tasks') {
          newItem.children = newItem.children.filter(
            (child) => child.url !== '/logBatchSearch'
          );
        }

        return newItem;
      });
    } else {
      updatedMenu = [...loginState.menuItems];
    }
    setMenuItems(updatedMenu);
  }, [loginState, generalSystemParameterDetails?.[0]?.checkLogUsesBatchInd]);

  useEffect(() => {
    if (loginState) {
      axios.interceptors.request.use(
        async function (config) {
          let accessToken = localStorage.getItem('accessToken');
          if (!accessToken) {
            axios.Cancel('Operation cancelled due to lack of accessToken');
          } else {
            config.headers.Username = loginState?.logInUser
              ? loginState.logInUser
              : null;
            config.headers.Authorization = accessToken;
            config.headers['X-CMDS-APP-CODE'] =
              process.env.REACT_APP_CMDS_APP_CODE;
            /*  if (
              config.url.includes('ApplicationConfigurationUser') ||
              config.url.includes('cxf/api/')
            ) {
              return config;
            } */
            config.timeout = process.env.REACT_APP_API_REQ_TIMEOUT;
          }
          return config;
        },
        function (error) {
          return Promise.reject(error);
        }
      );

      axios.interceptors.response.use(
        function (response) {
          return response;
        },
        function (error) {
          let e;
          try {
            e = error.toJSON();
          } catch (err) {
            e = error;
          }
          if (window.location.pathname == '/dashboard') {
            setTimedOutMsg(null);
          } else if (
            e.code == 'ECONNABORTED' ||
            error.message == 'Network Error'
          ) {
            setTimedOutMsg(FAIL_PROCESSING_REQUEST);
          } else if (error?.message == 'Request failed with status code 401') {
            props.setLogOut();
            setTimeout(() => {
              window.location = '/';
            }, 1000);
          } else {
            setTimedOutMsg(null);
          }
          return Promise.reject(error);
        }
      );
    }
  }, [loginState]);

  menuItems &&
    menuItems.length > 0 &&
    menuItems.map((item) => {
      if (item.name === 'Invoice') {
        item.icon = icons.Iconinvoice;
      } else if (item.name === 'CMS') {
        item.icon = icons.IconCMS;
      } else if (item.name === 'Tasks') {
        item.icon = icons.Icontasks;
      } else if (item.name === 'Maintain') {
        item.icon = icons.Iconmaintain;
      } else if (item.name === 'Display') {
        item.icon = icons.Icondisplay;
      } else if (item.name === 'Research') {
        item.icon = icons.Iconresearch;
      } else if (item.name === 'Summary Reports') {
        item.icon = icons.Iconchartbars;
      } else if (item.name === 'Detail Reports') {
        item.icon = icons.Iconchartbars;
      } else if (item.name === 'State Reports') {
        item.icon = icons.Iconchartbars;
      } else if (item.name === 'System') {
        item.icon = icons.Iconsystem;
      } else if (item.name === 'Help') {
        item.icon = icons.iconHelp;
      }
    });

  const getDrawer = localStorage.getItem('drawerIsOpen');
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    localStorage.removeItem('tabItemsData');
    localStorage.removeItem('accessToken');
    // getUserDefaultValues(logInUser);
    props.history.push({
      pathname: '/dashboard',
    });
  }, []);

  useEffect(() => {
    setDrawerOpen(_.isNull(getDrawer) ? true : getDrawer);
  }, [getDrawer]);

  const toggleDrawer = () => {
    setDrawerOpen(!drawerIsOpen);
  };

  const handleDrawerOpen = () => {
    setDrawerOpen(true);
    setMainClass('');
  };

  const handleOpenPopup = (navTo, state) => {
    if (props.location.pathname !== navTo) {
      props.history.push({ pathname: navTo, state: state });
    }
    setOpenClose(true);
  };

  const handleClosePopup = () => {
    setOpenClose(false);
    setMenuActiveState('');
    setActiveTabValue('');
  };

  const handleClick = (item, parent) => {
    $('.dashBoard').removeClass('highlighted-side-nav');
    setMenuState((prevState) => ({
      [item]: !prevState[item],
      [parent]: prevState[parent],
    }));
    setMenuActiveState(item);
  };

  const handleinitialClick = (item, parent) => {
    setMenuState((prevState) => ({
      [item]: !prevState[item],
      [parent]: !prevState[parent],
    }));
  };

  const handleClickDashboard = () => {
    if (menuState) {
      $('.dashBoard').addClass('highlighted-side-nav');
    }
    setMenuActiveState('');
    setMenuState(false);
    props.history.push({
      pathname: '/dashboard',
    });
  };

  const handleLinkClick = (e, subOption) => {
    $('.dashBoard').removeClass('highlighted-side-nav');
    const { url, name } = subOption;

    if (url === '/checks') {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) == null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));

      if (updateTabs.findIndex((item) => item.navTo === '/check') !== -1) {
        dispatch(clearReduxMaintainCheckSearchScreen());
        const filterArr = updateTabs.filter((item) => item.navTo !== '/check');
        localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
      }
      dispatch(setIsSearchCheckFromDisplay(true));
    } else if (url === '/check') {
      const updateTabs =
        JSON.parse(localStorage.getItem('tabItemsData')) == null
          ? []
          : JSON.parse(localStorage.getItem('tabItemsData'));

      if (updateTabs.findIndex((item) => item.navTo === '/checks') !== -1) {
        dispatch(clearReduxMaintainCheckSearchScreen());
        const filterArr = updateTabs.filter((item) => item.navTo !== '/checks');
        localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
      }
      dispatch(setIsSearchCheckFromDisplay(false));
    }

    const tabItemsData =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const isAlreadyAvailable = tabItemsData.findIndex(
      (item) => item.navTo === url
    );
    if (isAlreadyAvailable === -1) {
      tabItemsData.push({
        navTo: url,
        value: url === '/rebatePriceSearch' ? 'Rebate Price Search' : name,
        isFormDirty: false,
        isFormSave: false,
        isFormError: false,
        isRefresh: true,
      });

      if (
        updateTabs &&
        updateTabs.filter((x) => {
          return x.navTo !== url;
        }).length > 0
      ) {
        tabItemsData
          .filter((x) => {
            return x.navTo !== url;
          })
          .map((item) => {
            item.isFormDirty = updateTabs.filter((x) => {
              return x.navTo === item.navTo;
            })[0].isFormDirty;
            item.isFormSave = updateTabs.filter((x) => {
              return x.navTo === item.navTo;
            })[0].isFormSave;
            item.isFormError = updateTabs.filter((x) => {
              return x.navTo === item.navTo;
            })[0].isFormError;
            return item;
          });
      }
    }
    if (url === '/check') {
      const filterArr = tabItemsData.filter(
        (item) => item.navTo !== '/searchViewCheckAllocation'
      );
      localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
      dispatch(clearReduxMaintainCheckSearchScreen());
    } else if (url === '/searchViewCheckAllocation') {
      const filterArr = tabItemsData.filter((item) => item.navTo !== '/check');
      localStorage.setItem('tabItemsData', JSON.stringify(filterArr));
      dispatch(clearReduxMaintainCheckSearchScreen());
    } else {
      localStorage.setItem('tabItemsData', JSON.stringify(tabItemsData));
    }
    if (url === 'Dashboard') {
      if (document.getElementById('iframe')) {
        document.getElementById('iframe').classList.add('hide');
      }
      if (document.getElementById('tableDisplay')) {
        document.getElementById('tableDisplay').classList.remove('hide');
      }
      if (document.getElementById('sidebar-div')) {
        document.getElementById('sidebar-div').classList.remove('hide');
      }
      if (document.getElementById('alert-div')) {
        document.getElementById('alert-div').classList.remove('hide');
      }
      if (document.getElementById('main-col')) {
        document.getElementById('main-col').classList.remove('col-lg-12');
      }
      if (document.getElementById('dashboard-heading')) {
        document.getElementById('dashboard-heading').classList.remove('hide');
      }
      if (document.getElementById('banner-section')) {
        document.getElementById('banner-section').classList.remove('hide');
      }
    } else if (name === 'Release Notes') {
      localStorage.setItem('tabItemsData', JSON.stringify([]));
      openReleaseNotesUrl();
    } else if (name === 'Help Index') {
      localStorage.setItem('tabItemsData', JSON.stringify([]));
      openHelpModuleUrl('Default.htm');
    } else if (name === 'About') {
      props.history.push({
        pathname: '/about',
      });
    }
  };

  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth < 1024) {
        $('body').addClass('leftNavOff');
      }
    }
    window.addEventListener('resize', handleResize);
  });

  const toggleSideBar = () => {
    setMenuState({});
    if ($('body').hasClass('leftNavOff')) {
      $('body').removeClass('leftNavOff');
    } else {
      $('body').addClass('leftNavOff');
    }
  };

  useEffect(() => {
    if (window.location.pathname) {
      let thisparent = '';
      let item = '';
      menuItems.map((parent) => {
        parent.children.map((children) => {
          if (children.url === window.location.pathname) {
            item = parent.name;
            setMenuActiveState({ [item]: true });
            setMenuElementActive({ [children.name]: true });
            handleinitialClick(item, thisparent);
          } else if (children.children) {
            children.children.map((subchildren) => {
              if (subchildren.url === window.location.pathname) {
                thisparent = parent.name;
                item = children.name;
                setMenuActiveState({ [thisparent]: true });
                setMenuElementActive({ [subchildren.name]: true });
                handleinitialClick(item, thisparent);
              }
            });
          }
        });
      });
    }
    const screen = $(window);
    if (screen.width() < 1024) {
      $('body').addClass('leftNavOff');
    }
  }, []);

  const handleCloseTabData = () => {
    const updateTabs = JSON.parse(localStorage.getItem('tabItemsData'));
    const newObj =
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.map((item) => {
        const isContractTab =
          props.location.pathname === '/contract' ||
          props.location.pathname === '/contractreport';
        if (isContractTab) {
          item.isFormSave = item.navTo === props.location.pathname;
        } else if (item.value === activeTabValue) {
          item.isFormSave = true;
        } else {
          item.isFormSave = false;
        }
        return item;
      });
    localStorage.setItem('tabItemsData', JSON.stringify(newObj));
    setOpenClose(false);
  };

  const handleCancelTab = () => {
    setOpenClose(false);
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const isContractTab =
      props.location.pathname === '/contract' ||
      props.location.pathname === '/contractreport';
    const filtered = updateTabs.filter((item) => {
      if (isContractTab) {
        return item.navTo !== props.location.pathname;
      }
      return item.value !== menuActiveState;
    });
    localStorage.setItem('tabItemsData', JSON.stringify(filtered));
    if (filtered.length > 0) {
      props.history.push({
        pathname: filtered[filtered.length - 1]?.navTo,
        state: filtered[filtered.length - 1]?.state,
      });
    } else {
      props.history.push({
        pathname: '/dashboard',
      });
    }
    dispatch(clearReduxForFilterAndSort(props.location.pathname));
    if (
      props.location.pathname === '/letterTemplate' ||
      props.location.pathname === '/letterTemplateDetail' ||
      props.location.pathname === '/displayLetterPreview'
    ) {
      dispatch(clearLetterTemplatePage());
    }
    if (props.location.pathname === '/log-check') {
      dispatch(clearReduxLogCheckScreen());
    }
    if (props.location.pathname === '/updateGeneralParam') {
      dispatch(clearReduxUpdateGeneralParamScreen());
    }
    if (props.location.pathname === '/labelerDifferences') {
      dispatch(clearReduxForLabelerDifferenceScreen());
    }
    if (props.location.pathname === '/checkAllocDetail') {
      dispatch(clearReduxViewCheckAllocateScreen());
    }
    if (props.location.pathname === '/maintain-check') {
      dispatch(clearReduxMaintainCheckDetailScreen());
    }
    if (props.location.pathname === '/suspendedCheck') {
      dispatch(clearReduxSuspendedCheckScreen());
    }
    if (props.location.pathname === '/userList') {
      dispatch(clearReduxUserListScreen());
    }
    if (props.location.pathname === '/display-check') {
      dispatch(clearReduxDisplayCheckDetailScreen());
    }
    if (props.location.pathname === '/userDefault') {
      dispatch(clearReduxUserDefaultScreen());
    }
    if (props.location.pathname === '/codeTable') {
      dispatch(clearReduxCodeTablesScreen());
    }
    if (props.location.pathname === '/priceType') {
      dispatch(clearReduxPriceTypeScreen());
    }
    if (props.location.pathname === '/ProcedureResults') {
      dispatch(clearReduxProduceResultSearchScreen());
    }
    if (props.location.pathname === '/ProcedureResultDetails') {
      dispatch(clearReduxProduceResultDetailScreen());
    }
    if (props.location.pathname === '/unitConversion') {
      dispatch(clearReduxFirstScreenUnitConversion());
    }
    if (props.location.pathname === '/MaintainCMSMatDrugs') {
      dispatch(resetMatDrugStore());
    }
    if (props.location.pathname === '/unitConversion-detail') {
      dispatch(clearReduxDetailScreenUnitConversion());
    }
    if (props.location.pathname === '/disputes') {
      // dispatch(clearReduxForDisputeSerachScreen());
    }
    if (props.location.pathname === '/disputesDetails') {
      dispatch(clearReduxForDisputeDetailScreen());
    }
    if (props.location.pathname === '/NDCDisputesDetails') {
      dispatch(clearReduxForNdcDisputeDetailScreen());
    }
    if (props.location.pathname === '/manufacturer-detail') {
      dispatch(clearReduxManufacturerSecondScreen());
    }
    if (props.location.pathname === '/createContract') {
      dispatch(clearReduxMaintainContractDetailScreen());
    }

    if (props.location.pathname === '/underThresholdInvoice') {
      dispatch(clearReduxUnderThresholdInvSearchScreen());
    }
    if (props.location.pathname === '/ndc') {
      dispatch(resetNDCData());
    }
    if (props.location.pathname === '/ineligibleProviders') {
      dispatch(ClearReduxDataIneligibleProviderScr());
    }
    if (props.location.pathname === '/maintainIneligibleCPT') {
      dispatch(resetIneligibleCPTStore());
    }
    if (props.location.pathname === '/ndc-details') {
      dispatch(resetNDCDetailsData());
    }
    if (
      props.location.pathname === '/claim' ||
      props.location.pathname === '/selected-claim'
    ) {
      dispatch(clearReduxForClaimSearchScreen(props.location.pathname));
    }
    if (
      props.location.pathname === '/units-claim' ||
      props.location.pathname === '/units-selected-claim'
    ) {
      dispatch(clearReduxNumberOfUnitSearchScreen(props.location.pathname));
    }
    if (
      props.location.pathname === '/claim' ||
      props.location.pathname === '/selected-claim'
    ) {
      dispatch(clearReduxDisplayClaim(props.location.pathname));
    }
    if (
      props.location.pathname === '/group' ||
      props.location.pathname === '/group-maintain'
    ) {
      dispatch(clearReduxForMaintainGroupScreen(props.location.pathname));
    }
    if (
      props.location.pathname === '/client' ||
      props.location.pathname === '/maintain'
    ) {
      dispatch(clearReduxForMaintainClientScreen(props.location.pathname));
    }
    if (
      props.location.pathname === '/plan' ||
      props.location.pathname === '/createNewPlan'
    ) {
      // dispatch(clearReduxForMaintainPlanScreen(props.location.pathname));
    }
    if (
      props.location.pathname === '/RequestDrugPriceLoadDetails' ||
      props.location.pathname === '/RequestDrugPriceLoad'
    ) {
      dispatch(resetRequestDurgPriceLoadStore(props.location.pathname));
    }
    if (
      props.location.pathname === '/CMSQuarterlyReporting'
      //|| props.location.pathname === '/DisplayCMSQuarterlyReporting'
    ) {
      props.dispatch(clearReduxDataOnCMSQtrReport(props.location.pathname));
    }
    if (
      props.location.pathname === '/request-invoice-report' ||
      props.location.pathname === '/invoice-report-details'
    ) {
      dispatch(clearReduxForInvoiceReportScreen(props.location.pathname));
    }
    if (props.location.pathname === '/provider') {
      dispatch(clearReduxProviderSearchScreen());
    }
    if (props.location.pathname === '/viewUnderThresholdInvoice') {
      dispatch(clearReduxUnderThresholdInvDetailScreen());
    }
    if (props.location.pathname === '/providerDetails') {
      dispatch(clearReduxProviderDetailScreen());
    }
    if (props.location.pathname === '/generateInvoice') {
      dispatch(clearReduxForGenerateSearchScreen());
    }
    if (props.location.pathname === '/generateInvoiceDetail') {
      dispatch(clearReduxForGenerateDetailScreen());
    }
    if (props.location.pathname === '/comment') {
      dispatch(clearReduxForSystemLevelCommCorrespondence());
    }
    if (props.location.pathname === '/invoiceAuditsDetail') {
      dispatch(clearReduxForInvoiceAuditDetailScreen());
    }
    if (props.location.pathname === '/ClaimAuditViewDetails') {
      dispatch(dispatchClaimAuditDetailTabData([]));
      dispatch(dispatchClaimAuditDetails([]));
      dispatch(dispatchPageCountwithDetails({}));
      dispatch(setChangesDataList([]));
    }
    if (props.location.pathname === '/reminderRecipients') {
      dispatch(clearReduxReminderRecipientsScreen());
    }
    if (props.location.pathname === '/requestDataNicheReport') {
      dispatch(clearReduxReqDataNicheReportScreen());
    }
    if (props.location.pathname === '/display-invoice') {
      dispatch(clearReduxDisplayInvoiceDetailScreen());
    }
    if (props.location.pathname === '/createNewPlan') {
      dispatch(setPlanTabData({}));
    }
    if (props.location.pathname === '/group-maintain') {
      dispatch(setGroupTabDataAction(null));
      dispatch(saveContactData(null));
    }
    if (props.location.pathname === '/userDefault') {
      dispatch(dispatchTabChanges({}));
    }
    if (props.location.pathname === '/createContract') {
      dispatch(clearReduxMaintainContractDetailScreen());
    }

    if (props.location.pathname === '/priceLevel') {
      dispatch(storePriceLevelErrors([]));
      dispatch(
        storePriceLevelSearchData({
          rebateProgramCd: '-1',
          planType: 'COMM',
          drugFamily: 'all',
          quarterValue: generateQuarter(),
        })
      );
    }
    if (props.location.pathname === '/priceDetails') {
      dispatch(storePriceDetailErrors([]));
      dispatch(storeUpdatedPage({}));
    }
    if (props.location.pathname === '/providerReview') {
      dispatch(dispatchGetProvider([]));
      dispatch(dispatchGetCommonData({}));
      dispatchBottonState('');
    }
    if (props.location.pathname === '/providerReviewDetail') {
      dispatch(dispatchReviewProblemDropdown({}));
      dispatch(dispatchReviewCorrectionDropdown({}));
      dispatch(dispatchGetDetailData({}));
      dispatch(setSelectTableData({}));
      dispatch(dispatchNdcGridDetail([]));
      dispatch(dispatchProviderReviewClaimHeader([]));
      dispatch(dispatchProviderFrozenComplete(''));
      dispatch(handleErrorMessages({}));
      dispatch(dispatchProblemCode(''));
      dispatch(dispatchcorrectionCode(''));
      dispatch(dispatchGetProviderDropDown({}));
      dispatch(dispatchBottonState(''));
    }
    if (props.location.pathname === '/logBatchSearch') {
      dispatch(clearReduxForLogBatchFirstScreen());
    }
    if (props.location.pathname === '/logBatchDetail') {
      dispatch(clearReduxForLogBatchSecondScreen());
    }
    if (props.location.pathname === '/allocatePayment') {
      dispatch(clearReduxAllocatePaymentFirstScreen());
    }
    if (props.location.pathname === '/pickInvoiceAssociateWithCheck') {
      dispatch(clearReduxAllocatePaymentSecondScreen());
    }
    if (props.location.pathname?.includes(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)) {
      const activeInvNum = props.location.pathname
        ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
        ?.split('-')[1];
      const activeCheckLogNum = props.location.pathname
        ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
        ?.split('-')[0];
      dispatch(
        clearReduxAllocatePaymentThirdScreen(
          activeInvNum,
          activeCheckLogNum,
          props.history
        )
      );
    }
    dispatch(resetReduxStore(props.location.pathname));
  };

  const helpBtnHandler = () => {
    const helpPathUrl = getHelpUrl.pathname;
    let getHelpIdFrmJson = routeHelpTabConfig.filter((path) => {
      if (helpPathUrl === path.route) {
        return path;
      }
    });

    const routeToHelperIdMap = {
      '/allocatePaymentDetail': '2176',
      '/arSummaryByMfg': '2206',
      '/mfgAccountRec': '2209',
      '/AccRecNDCDetail': '2204',
      '/ARSummaryByQtr': '2207',
      '/QtrAccountsRec': '2210',
    };

    for (const route of Object.keys(routeToHelperIdMap)) {
      if (helpPathUrl.includes(route)) {
        getHelpIdFrmJson = [
          { route: route, helperId: routeToHelperIdMap[route] },
        ];
        break;
      }
    }

    const getHelpId =
      getHelpIdFrmJson.length > 0 ? getHelpIdFrmJson[0].helperId : '';
    if (getHelpIdFrmJson.length > 0) {
      openHelpModuleUrl('Default.htm', getHelpId);
    } else {
      openHelpModuleUrl('Default.htm');
    }
  };

  const handler = (children, name) => {
    const linkDisable = '';
    const privileges = '';
    /* const nestedLevel = 0;
    const isSelected = true;

    const Item1 = Item({
      ...children,
      nestedLevel,
      isSelected,
      classes,
      toggleDrawer,
      drawerIsOpen,
    }); */
    if (children) {
      return children
        .filter((x) => {
          return x.navTo !== '/logBatchSearch';
        })
        .map((subOption) => {
          if (subOption.children.length === 0) {
            return (
              <List
                className="side-menu-list"
                key={subOption.name}
                disablePadding
              >
                <Link
                  to={subOption.url}
                  onClick={(e) => handleLinkClick(e, subOption)}
                  title={subOption.name}
                >
                  <ListItem
                    button
                    className={clsx(
                      classes.nestedFolder,
                      subOption.url !== '/dashboard'
                        ? window.location.pathname === subOption.url
                          ? 'highlighted-side-nav'
                          : ''
                        : ''
                    )}
                  >
                    <ListItemText primary={subOption.name} />
                  </ListItem>
                </Link>
              </List>
            );
          }

          return (
            <List className="side-menu-list" key={subOption.name}>
              <ListItem
                title={subOption.name}
                button
                className={`${
                  menuActiveState === subOption.name
                    ? 'highlighted-side-nav'
                    : ''
                }`}
                onClick={() => handleClick(subOption.name, name)}
              >
                {subOption.icon && <div>{subOption.icon}</div>}
                <ListItemText primary={subOption.name} />
                {menuState[subOption.name] ? <ExpandLess /> : <ExpandMore />}
              </ListItem>
              <Collapse
                in={menuState[subOption.name]}
                timeout="auto"
                unmountOnExit
              >
                {handler(
                  subOption.children,
                  subOption.name,
                  linkDisable,
                  privileges
                )}
              </Collapse>
            </List>
          );
        });
    }
  };

  const HamburgerIcon = () => (
    <Hamburger isOpen={drawerIsOpen} toggleDrawer={toggleDrawer} />
  );
  React.useEffect(() => {
    const handler = () => {
      clearMfgARColumnStateFromLocalStorage();
    };
    window.addEventListener('beforeunload', handler);
  });
  return (
    <>
      <SaveCancelPopup
        open={openClose}
        title="Close"
        closeTab
        onConfim={() => {
          if (openClose) handleCloseTabData();
        }}
        onCancel={() => {
          if (openClose) handleCancelTab();
        }}
        onClose={() => {
          if (openClose) handleClosePopup();
        }}
      />
      <CommonModal
        open={openCnf}
        viewAction
        className="dialog-420"
        viewHeader
        onOk={() => {
          window.close();
          setOpenCnf(false);
        }}
        okTitle="Ok"
        closeTitle="Cancel"
        onClose={() => setOpenCnf(false)}
        modalTitle="Logout"
        childrenComponent={'Are you sure you want to logout?'}
      />
      <Orange />
      <div className="row" id="mainContentHeader">
        <div className="col-12">
          <nav
            position="relative"
            className="navbar bg-white rounded flex-nowrap"
          >
            <div className="top-logo-bar">
              <Link to="/dashboard">
                <img
                  className="hide-on-print"
                  src="/logo2.png"
                  alt="conduent"
                />
              </Link>
              <span className="logo-text">
                {AppConstants.DASHBOARD_HEADER_TEXT}
              </span>
            </div>

            <div className={classes.loginStatus}>
              <OverlayTrigger
                placement="bottom"
                overlay={<Tooltip id="action-tooltip">Logout</Tooltip>}
              >
                <div
                  className="top-bell-icon logout-icon"
                  onClick={() => setOpenCnf(true)}
                >
                  {/* <SVGComponent iconName="Icon-printer" /> */}
                  <PowerSettingsNewIcon />
                </div>
              </OverlayTrigger>
              <div className="top-print-icon">
                <OverlayTrigger
                  placement="bottom"
                  overlay={<Tooltip id="action-tooltip">Help</Tooltip>}
                >
                  <div onClick={() => helpBtnHandler()}>
                    <SVGComponent iconName="Icon-help" />
                  </div>
                </OverlayTrigger>
              </div>
              <div className="user-action-btn frr-app-header-dropdown">
                {logInUser}
                <Avatar
                  size="30"
                  round
                  facebook-id="invalidfacebookusername"
                  src="http://www.gravatar.com/avatar/a16a38cdfe8b2cbd38e8a56ab93238d3"
                  alt="User Avatar"
                />
              </div>
              {/* <Dropdown className='user-action-btn frr-app-header-dropdown'>
                <Dropdown.Toggle variant='secondary' id='dropdown-basic'>
                  {localStorage.getItem('logInUser')}
                  <Avatar
                    size='30'
                    round
                    facebook-id='invalidfacebookusername'
                    src='http://www.gravatar.com/avatar/a16a38cdfe8b2cbd38e8a56ab93238d3'
                    alt='User Avatar'
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href='/AddUser'
                    className={classes.dropDownItem}
                  >
                    <i className='fa fa-user-o' aria-hidden='true' />
                    &nbsp; User Profile
                  </Dropdown.Item>
                  <Dropdown.Item
                    href='/ChangePassword'
                    className={classes.dropDownItem}
                  >
                    <i className='fa fa-cog' aria-hidden='true' />
                    &nbsp; Change Password
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={props.setLogOut}
                    className={classes.dropDownItem}
                  >
                    <i className='fa fa-sign-out' aria-hidden='true' />
                    &nbsp; Logout
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
            </div>
          </nav>
        </div>
      </div>
      <div className="main-container">
        <div
          className={clsx(
            classes.wrapper,
            'main-body container-fluid',
            !drawerIsOpen ? 'minimize-sidebar' : ''
          )}
        >
          <CssBaseline />
          <Drawer
            className={clsx(classes.drawer, 'side-drawer')}
            variant="permanent"
            anchor="left"
            open={drawerIsOpen}
            classes={{
              paper: !drawerIsOpen
                ? classes.drawerPaperShrink
                : classes.drawerPaper,
            }}
          >
            <div className="side-menu-list">
              <div
                title="Dashboard"
                className={`MuiButtonBase-root MuiListItem-root MuiListItem-gutters MuiListItem-button dashBoard ${
                  Object.keys(menuActiveState).length > 0
                    ? ''
                    : 'highlighted-side-nav'
                }`}
                style={{ height: 45 }}
              >
                <div
                  className={`${menuItems.length > 0 ? '' : 'hamburger-icon'}`}
                >
                  <HamburgerIcon onClick={toggleSideBar} />
                  <div
                    className="MuiListItemText-root"
                    style={{ marginTop: '-23px', marginLeft: 30 }}
                  >
                    <span
                      className="MuiTypography-root MuiListItemText-primary MuiTypography-body1"
                      onClick={handleClickDashboard}
                    >
                      Dashboard
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div>{handler(menuItems, null)}</div>
          </Drawer>

          <MainFrame
            logInUserID={logInUserID}
            handleDrawerOpen={handleDrawerOpen}
            setLogOut={props.setLogOut}
            classes={classes}
            uuid={props.uuid}
            history={props.history}
            dispatch={dispatch}
            handleOpenPopup={(value, state) => handleOpenPopup(value, state)}
            setMenuActiveState={setMenuActiveState}
            handleClickDashboard={handleClickDashboard}
            setActiveTabValue={setActiveTabValue}
          />
        </div>
      </div>
      <Footer main />
    </>
  );
}
function clearMfgARColumnStateFromLocalStorage() {
  try {
    const keys = Object.keys(localStorage).filter((key) =>
      key.startsWith('aggrid:colstate:MfgAccountsRec:')
    );
    // console.log("keys",keys)
    keys.forEach((key) => localStorage.removeItem(key));
  } catch (e) {
    //will add if req
  }
}
const getMainFrameSizing = () => {
  const mainContent = document.getElementById('mainContent');

  const header = document.getElementById('mainContentHeader');
  const footer = document.getElementById('mainContentFooter');
  const headerH = header
    ? header.getBoundingClientRect().bottom - header.getBoundingClientRect().top
    : 0;
  const footerH = footer
    ? footer.getBoundingClientRect().bottom - footer.getBoundingClientRect().top
    : 0;
  const mainContentBounds = mainContent
    ? mainContent.getBoundingClientRect()
    : null;
  const mainContentH = mainContentBounds
    ? mainContentBounds.bottom - mainContentBounds.top
    : 0;
  const _minHeight = mainContentH ? mainContentH - headerH - footerH : 0;

  const _hasScroll = mainContent
    ? mainContent.scrollHeight !== mainContent.clientHeight
    : false;

  return { _minHeight, _hasScroll };
};

const getMainScrollbarWidth = () => {
  const mainContent = document.getElementById('mainContent');

  mainContent.style.overflow = 'scroll';
  const _marginRightValue =
    mainContent.offsetWidth - mainContent.clientWidth - 2;
  mainContent.style.overflow = 'auto';

  return _marginRightValue;
};

class MainFrame extends React.Component {
  state = {
    scrollbar: false,
    marginRightValue: 0,
    minHeight: 0,
    mainFrameRef: React.createRef(),
  };

  timer = null;

  observer;

  componentDidMount() {
    this.setState({
      marginRightValue: getMainScrollbarWidth(this.state.mainFrameRef),
    });
    this.observer = new MutationObserver(this.update);
    this.observer.observe(this.state.mainFrameRef.current, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  componentDidUpdate() {
    this.updateWithrateLimit();
  }

  componentWillUnmount() {
    this.observer.disconnect();
  }

  updateWithrateLimit = () => {
    if (this.timer) return;
    this.timer = setTimeout(() => {
      this.update();
      clearInterval(this.timer);
    }, 100);
  };

  update = () => {
    const { _minHeight, _hasScroll } = getMainFrameSizing();
    if (_hasScroll !== this.state.scrollbar) {
      this.setState({ scrollbar: _hasScroll });
    }
    if (_minHeight !== this.state.minHeight) {
      this.setState({ minHeight: _minHeight });
    }
  };

  handleNav = () => {
    this.props.history.push({ pathname: '/userDefault' });
  };

  closeTab(e, tabValue, navTo, state) {
    const _this = this;
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    if (navTo === '/DisplayCMSQuarterlyReporting') {
      const newObj =
        updateTabs &&
        updateTabs.length > 0 &&
        updateTabs.map((item) => {
          if (item.navTo === `/DisplayCMSQuarterlyReporting`) {
            item.isPopDisplay = true;
          }
          return item;
        });
      localStorage.setItem('tabItemsData', JSON.stringify(newObj));
      _this.props.dispatch(dispatchFlag(true));
    } else if (
      updateTabs &&
      updateTabs.length > 0 &&
      updateTabs.filter((x) => {
        if (navTo === '/contract' || navTo === '/contractreport') {
          return x.navTo === navTo && x.isFormDirty;
        }
        return x.value === tabValue && x.isFormDirty;
      }).length > 0
    ) {
      _this.props.setMenuActiveState(tabValue);
      _this.props.setActiveTabValue(tabValue);
      _this.props.handleOpenPopup(navTo, state);
    } else {
      const filtered = updateTabs.filter((item) => {
        if (navTo === '/contract' || navTo === '/contractreport') {
          return item.navTo !== navTo;
        }
        return item.value !== tabValue;
      });
      localStorage.setItem('tabItemsData', JSON.stringify(filtered));
      if (filtered.length > 0) {
        _this.props.history.push({
          pathname: filtered[filtered.length - 1]?.navTo,
          state: filtered[filtered.length - 1]?.state,
        });
      } else {
        _this.props.handleClickDashboard();
        _this.props.history.push({
          pathname: '/dashboard',
        });
      }
      _this.props.dispatch(clearReduxForFilterAndSort(navTo));
      if (navTo === '/manufacturer') {
        _this.props.dispatch(setSearchManufacturerTab({}));
        _this.props.dispatch(cancelProviderApiRequest());
      }
      if (navTo === '/manufacturer-detail') {
        _this.props.dispatch(clearReduxManufacturerSecondScreen());
      }
      if (navTo === '/createContract') {
        _this.props.dispatch(clearReduxMaintainContractDetailScreen());
      }
      if (
        navTo === '/reqInvoicesQtrnotPaid' ||
        navTo === 'invoicesforQtrnotPaidDetail'
      ) {
        _this.props.dispatch(clearReduxInvoiceQtr());
      }
      if (navTo === '/viewUnderThresholdInvoice') {
        _this.props.dispatch(clearReduxUnderThresholdInvDetailScreen());
      }
      if (navTo === '/ineligibleProviders') {
        _this.props.dispatch(ClearReduxDataIneligibleProviderScr());
      }
      if (navTo === '/maintainIneligibleCPT') {
        _this.props.dispatch(resetIneligibleCPTStore());
      }
      if (navTo === '/claim') {
        _this.props.dispatch(clearReduxForClaimSearchScreen(navTo));
        _this.props.dispatch(clearReduxDisplayClaim(navTo));
      }
      if (navTo === '/units-claim' || navTo === '/units-selected-claim') {
        _this.props.dispatch(clearReduxNumberOfUnitSearchScreen(navTo));
      }
      if (
        navTo === '/view-calculated-interest' ||
        navTo === '/calculated-interest-details'
      ) {
        _this.props.dispatch(clearReduxCalculatedInterest(navTo));
      }
      if (navTo === '/group') {
        _this.props.dispatch(setSelectedClientAction({}));
      }
      if (navTo === '/client') {
        _this.props.dispatch(setReduxDataIntoSearchScr({}));
      }
      if (navTo === '/plan') {
        _this.props.dispatch(setReduxDataSearchScreen({}));
      }
      if (
        navTo === '/RequestDrugPriceLoadDetails' ||
        navTo === '/RequestDrugPriceLoad'
      ) {
        _this.props.dispatch(resetRequestDurgPriceLoadStore(navTo));
      }
      if (
        navTo === '/CMSQuarterlyReporting'
        //|| navTo === '/DisplayCMSQuarterlyReporting'
      ) {
        _this.props.dispatch(clearReduxDataOnCMSQtrReport(navTo));
      }
      if (
        navTo === '/invoice-report-details' ||
        navTo === '/request-invoice-report'
      ) {
        _this.props.dispatch(clearReduxForInvoiceReportScreen(navTo));
      }
      if (navTo === '/providerDetails') {
        _this.props.dispatch(clearReduxProviderDetailScreen());
      }
      if (navTo === '/priceLevel') {
        _this.props.dispatch(storePriceLevelErrors([]));
        _this.props.dispatch(
          storePriceLevelSearchData({
            rebateProgramCd: '-1',
            planType: 'COMM',
            drugFamily: 'all',
            quarterValue: generateQuarter(),
            manufacturerGrid: [],
            drugfamilyId: null,
            loadMfgGrid: true,
            loadDrugFamilyGrid: true,
            loadDrugTable: false,
          })
        );
      }
      if (navTo === '/priceDetails') {
        _this.props.dispatch(storePriceDetailErrors([]));
        _this.props.dispatch(storeUpdatedPage({}));
      }
      if (navTo === '/providerReview') {
        _this.props.dispatch(dispatchGetProvider([]));
        _this.props.dispatch(dispatchGetCommonData({}));
        _this.props.dispatch(dispatchBottonState(''));
      }
      if (navTo === '/providerReviewDetail') {
        _this.props.dispatch(dispatchReviewProblemDropdown({}));
        _this.props.dispatch(dispatchReviewCorrectionDropdown({}));
        _this.props.dispatch(dispatchGetDetailData({}));
        _this.props.dispatch(setSelectTableData({}));
        _this.props.dispatch(dispatchNdcGridDetail([]));
        _this.props.dispatch(dispatchProviderReviewClaimHeader([]));
        _this.props.dispatch(dispatchProviderFrozenComplete(''));
        _this.props.dispatch(handleErrorMessages({}));
        _this.props.dispatch(dispatchProblemCode(''));
        _this.props.dispatch(dispatchcorrectionCode(''));
        _this.props.dispatch(dispatchGetProviderDropDown({}));
        _this.props.dispatch(dispatchBottonState(''));
      }
      if (navTo === '/logBatchSearch') {
        // _this.props.dispatch(dispatchLogBatchTotalList([]));
        // _this.props.dispatch(setLogBatchTotalSelectListDetail([]));
        // _this.props.dispatch(errorMsg({}));
        // _this.props.dispatch(
        //   dispatchLogBatchFilterData({
        //     batchInCompleteStatus: 'I',
        //     isFilter: true,
        //     batchesForPayee: '-1',
        //     filterBatchesBy: 'noFilter',
        //   })
        // );
        _this.props.dispatch(clearReduxForLogBatchFirstScreen());
      }
      if (navTo === '/logBatchDetail') {
        // _this.props.dispatch(setLogBatchTotalSelectListDetail([]));
        // _this.props.dispatch(getLogBatchHistory());
        // _this.props.dispatch(getLogCheckDetails([]));
        // _this.props.dispatch(dispatchLogCheckDetails({}));
        // _this.props.dispatch(dispatchLogBatchTotalSelectedListDetail({}));
        // _this.props.dispatch(errorMsg({}));
        // _this.props.dispatch(dispatchLogBatchTotalList([]));
        _this.props.dispatch(clearReduxForLogBatchSecondScreen());
      }
      if (navTo === '/allocatePayment') {
        _this.props.dispatch(clearReduxAllocatePaymentFirstScreen());
      }
      if (navTo === '/pickInvoiceAssociateWithCheck') {
        _this.props.dispatch(clearReduxAllocatePaymentSecondScreen());
      }
      if (navTo?.includes(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)) {
        const activeInvNum = navTo
          ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
          ?.split('-')[1];
        const activeCheckLogNum = navTo
          ?.split(ALLOCATE_PAYMENT_DETAIL_SCREEN_URL)[1]
          ?.split('-')[0];
        _this.props.dispatch(
          clearReduxAllocatePaymentThirdScreen(
            activeInvNum,
            activeCheckLogNum,
            _this.props.history
          )
        );
      }
      if (navTo === '/assignDisputesSearch') {
        _this.props.dispatch(resetStore());
      }
      if (navTo === '/assignDisputesDetails') {
        _this.props.dispatch(clearAssignDetlReduxStore());
      }
      if (navTo === '/SearchRebate') {
        _this.props.dispatch(clearReduxSearchRbt());
      }
      if (navTo === '/maintainRebate') {
        _this.props.dispatch(clearMaintainRbtRedux());
      }
      if (navTo === '/createRebate') {
        _this.props.dispatch(clearCreateRbtRedux());
      }

      /** reset store as an initial state */
      _this.props.dispatch(resetReduxStore(navTo));

      if (navTo === '/RequestClaimAudit') {
        _this.props.dispatch(clearPreloadedData());
      }
      if (navTo === '/drugFamily') {
        _this.props.dispatch(resetStoreDrugFamily());
        _this.props.dispatch(clearReduxDrugFamilyScreen());
      }
      if (navTo === '/drugFamilyDetail') {
        _this.props.dispatch(clearReduxDrugFamilyDetailScreen());
      }
      if (navTo === '/checksByInvoice') {
        _this.props.dispatch(clearReduxForChecksByInvoices());
      }
      if (navTo === '/reqAccReceivable') {
        // _this.props.dispatch(resetData());
        _this.props.dispatch(clearReqAccRecSearchPage(_this.props.history));
      }
      if (navTo === '/arSummaryByMfg') {
        _this.props.dispatch(resetARSummaryByMfgData());
      }
      if (navTo === '/ARSummaryByQtr') {
        _this.props.dispatch(clearARSummaryByQtrPage());
      }
      if (navTo.startsWith('/mfgAccountRec')) {
        try {
          const keys = Object.keys(localStorage).filter((key) =>
            key.startsWith('aggrid:colstate:MfgAccountsRec:')
          );
          // console.log('keys', keys);
          keys.forEach((key) => localStorage.removeItem(key));
        } catch (e) {
          //will add if req
        }
      }
      if (navTo === '/mfgAccountRec') {
        _this.props.dispatch(clearMfgAccountRecPage());
      }
      if (navTo.includes('/AccRecNDCDetail')) {
        _this.props.dispatch(clearMfgAccountRecPage());
      }
      if (navTo === '/AccRecNDCActivity') {
        _this.props.dispatch(clearAccountRecNDCActivityPage());
      }
      if (navTo === '/QtrAccountsRec') {
        _this.props.dispatch(clearQtrAccountRecPage());
      }
      if (navTo === '/ARManufacturer') {
        _this.props.dispatch(clearARManufacturerPage());
      }
      if (navTo === '/arSummaryByMfgAll') {
        _this.props.dispatch(resetARSummaryByMfgAllData());
      }
      if (navTo === '/arSummaryByQtrAll' || navTo === '/ARSummaryByQtrAll') {
        _this.props.dispatch(clearARSummaryByQtrAllPage());
      }
      if (navTo === '/AccRecNDCDetailAll') {
        _this.props.dispatch(clearAccRecNDCDetailAllPage());
      }
      if (navTo === '/QtrAccountsRecAll') {
        _this.props.dispatch(clearQtrAccountRecAllPage());
      }
      if (navTo === '/tBill') {
        _this.props.dispatch(dispatchClearTBillReduxStore());
      }
      if (navTo === '/excludedNDCs' || navTo === '/excludedNDCsDetail') {
        _this.props.dispatch(clearExcludedNDCsPage());
      }
      if (
        navTo === '/letterTemplate' ||
        navTo === '/letterTemplateDetail' ||
        navTo === '/displayLetterPreview'
      ) {
        _this.props.dispatch(clearLetterTemplatePage());
      }
      if (navTo === '/createLetter' || navTo === '/createLetterDetail') {
        _this.props.dispatch(clearCreateLetterPage());
      }
      if (navTo === '/letter' || navTo === '/displayLetterDetail') {
        _this.props.dispatch(clearDisplayLetterPage());
      }
      if (
        navTo === '/GenerateCollectionLetter' ||
        navTo === '/Collectionletterdetail'
      ) {
        _this.props.dispatch(clearGenerateCollectionLetterPage());
      }
      if (navTo === '/comment') {
        _this.props.dispatch(clearReduxForSystemLevelCommCorrespondence());
      }
      if (navTo === '/linknewdrugstodrugfamily') {
        // _this.props.dispatch(saveDrugSeq(null));
        _this.props.dispatch(clearReduxforLinkNewDrugsToDrugFamily());
      }
      if (navTo === '/request-invoice-detail') {
        _this.props.dispatch(clearReduxDisplayInvoiceSearchScreen());
      }
      if (navTo === '/display-invoice') {
        _this.props.dispatch(clearReduxDisplayInvoiceDetailScreen());
      }
      if (navTo === '/invoiceAudits') {
        _this.props.dispatch(clearReduxForInvoiceAuditSearchScreen());
      }
      if (navTo === '/invoiceAuditsDetail') {
        _this.props.dispatch(clearReduxForInvoiceAuditDetailScreen());
      }
      if (navTo === '/reminderRecipients') {
        _this.props.dispatch(clearReduxReminderRecipientsScreen());
      }
      if (navTo === '/requestDataNicheReport') {
        _this.props.dispatch(clearReduxReqDataNicheReportScreen());
      }
      if (navTo === '/ClaimAuditViewDetails') {
        _this.props.dispatch(dispatchClaimAuditDetailTabData([]));
        _this.props.dispatch(dispatchClaimAuditDetails([]));
        _this.props.dispatch(dispatchPageCountwithDetails({}));
        _this.props.dispatch(setChangesDataList([]));
      }
      if (navTo === '/cmsRosi') {
        _this.props.dispatch(clearReduxForCmsRosiSearchScrren());
        _this.props.dispatch(clearReduxForCmsRosiDetailsScrren());
      }
      if (navTo === '/contactAnomalies') {
        _this.props.dispatch(setContactAnomaliesTab({}));
        _this.props.dispatch(dispatchInputValue(1));
        _this.props.dispatch(dispatchTabValue('one'));
        _this.props.dispatch(clearReduxContactAnomaliesScreen());
      }
      if (navTo === '/calculateInterest') {
        _this.props.dispatch(clearReduxforCalculateInterestSearch());
      }
      if (navTo === '/providerReview') {
        _this.props.dispatch(
          handleErrorMessages({
            searchScreenErrors: [],
            detailScreenErrors: [],
          })
        );
      }
      if (navTo === '/log-check') {
        _this.props.dispatch(clearReduxLogCheckScreen());
      }
      if (navTo === '/updateGeneralParam') {
        _this.props.dispatch(clearReduxUpdateGeneralParamScreen());
      }
      if (navTo === '/checkAllocDetail') {
        _this.props.dispatch(clearReduxViewCheckAllocateScreen());
      }
      if (navTo === '/suspendedCheck') {
        _this.props.dispatch(clearReduxSuspendedCheckScreen());
      }
      if (navTo === '/display-check') {
        _this.props.dispatch(clearReduxDisplayCheckDetailScreen());
      }
      if (navTo === '/userList') {
        _this.props.dispatch(clearReduxUserListScreen());
      }
      if (navTo === '/userDefault') {
        _this.props.dispatch(clearReduxUserDefaultScreen());
      }
      if (navTo === '/codeTable') {
        _this.props.dispatch(clearReduxCodeTablesScreen());
      }
      if (navTo === '/ProcedureResults') {
        _this.props.dispatch(clearReduxProduceResultSearchScreen());
      }
      if (navTo === '/ProcedureResultDetails') {
        _this.props.dispatch(clearReduxProduceResultDetailScreen());
      }
      if (navTo === '/priceType') {
        _this.props.dispatch(clearReduxPriceTypeScreen());
      }
      if (navTo === '/unitConversion') {
        _this.props.dispatch(clearReduxFirstScreenUnitConversion());
      }
      if (navTo === '/MaintainCMSMatDrugs') {
        _this.props.dispatch(resetMatDrugStore());
      }
      if (navTo === '/unitConversion-detail') {
        _this.props.dispatch(clearReduxDetailScreenUnitConversion());
      }
      if (navTo === '/disputes') {
        // _this.props.dispatch(clearReduxForDisputeSerachScreen());
      }
      if (navTo === '/disputesDetails') {
        _this.props.dispatch(clearReduxForDisputeDetailScreen());
      }
      if (navTo === '/NDCDisputesDetails') {
        _this.props.dispatch(clearReduxForNdcDisputeDetailScreen());
      }
      if (navTo === '/underThresholdInvoice') {
        _this.props.dispatch(clearReduxDetailScreenUnitConversion());
      }
      if (navTo === '/provider') {
        _this.props.dispatch(clearReduxProviderSearchScreen());
      }
      if (navTo === '/generateInvoice') {
        _this.props.dispatch(setGenerateInvoiceSearchTab({}));
        _this.props.dispatch(handleErrorMesGenerateInvInRedux([]));
        _this.props.dispatch(dispatchQuarterData(''));
        _this.props.dispatch(dispatchPlanTypeFilterData({}));
        _this.props.dispatch(dispatchGenerateInvoiceCriteriaList([]));
      }
      if (navTo === '/generateInvoiceDetail') {
        _this.props.dispatch(setGenerateInvoiceDetailTab([]));
        _this.props.dispatch(setPervSearchScreenTabDataRedux([]));
        _this.props.dispatch(dispatchGetPlanTypeCd(''));
        _this.props.dispatch(setPdfInvoice(''));
        _this.props.dispatch(clearReduxForGenerateSearchScreen());
      }
      if (navTo === '/generateInvoiceDetail') {
        _this.props.dispatch(clearReduxForGenerateDetailScreen());
      }
      if (navTo === '/claimAuditSelect') {
        _this.props.dispatch(clearReduxForClaimAuditSelectScreen());
      }
      if (navTo === '/labelerDifferences') {
        _this.props.dispatch(clearReduxForLabelerDifferenceScreen());
      }
      if (navTo === '/cmsDrugFileDiscrepancies') {
        _this.props.dispatch(resetRedux({}));
        _this.props.dispatch(clearCmsDrugFileDiscrepancies());
      }
      if (navTo === '/letter') {
        _this.props.dispatch(resetReduxDL({}));
      }
      if (navTo === '/EventLogging') {
        _this.props.dispatch(clearReduxEventLoggingScreen());
      }
    }

    if (
      navTo === '/check' ||
      navTo === '/checks' ||
      navTo === '/searchViewCheckAllocation'
    ) {
      _this.props.dispatch(clearReduxMaintainCheckSearchScreen());
      window.sessionStorage.setItem('closeCheckTab', JSON.stringify(true));
    }
    if (navTo === '/maintain-check') {
      _this.props.dispatch(clearReduxMaintainCheckDetailScreen({}));
    }
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = today.getMonth() + 1; // Months start at 0!
    const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
    const currDate = `${mm}/${dd}/${yyyy}`;
    if (navTo === '/MailingLabel') {
      _this.props.dispatch(
        searchMailingRequestAction({
          rebateProgramCode: '-1',
          addressTypeCode: '-1',
          planType: '',
          copies: 1,
          manufacturer: 'All',
          invoiceMailedDate: currDate,
        })
      );
      _this.props.dispatch(handleFieldLevelErrMsg({}));
      _this.props.dispatch(handleHeaderErrorMessages([]));
      _this.props.dispatch(dispatchAllManufacturerRequestMailing([]));
      _this.props.dispatch(clearReduxMailingRequest([]));
    }
    if (navTo === '/cmsMismatch') {
      _this.props.dispatch(clearReduxForCmsMissMatchSearchScreen());
    }
    if (navTo === '/cmsMismatchDetail') {
      _this.props.dispatch(clearReduxForCmsMissMatchDetailScreen());
    }
    if (navTo === '/requestCurrentDisputeDisplay') {
      _this.props.dispatch(dispatchErrorMsgPerformDis([]));
      _this.props.dispatch(dispatchPerformDisputeResolutionObj({}));
      _this.props.dispatch(dispatchManufacturerValue([]));
      _this.props.dispatch(dispatchPerformDisputeClearRedux());
    }
    if (navTo === '/displayCurrentDisputes') {
      _this.props.dispatch(dispatchCurrentDisputesErr([]));
    }
    if (navTo === '/contract') {
      _this.props.dispatch(clearReduxMaintainContractSearchScreen());
    }

    if (navTo === '/disputes') {
      // _this.props.dispatch(resetStoreDisputes());
    }
    if (navTo === '/rosiInconsistencies') {
      _this.props.dispatch(clearReduxForRosiInconsistencies());
    }
    if (navTo === '/rosiInconsistenciesDetail') {
      _this.props.dispatch(clearReduxForRosiInconsistenciesDetail());
    }

    if (navTo === '/quarterlyPayment') {
      _this.props.dispatch(clearQtrlyPayTab());
    }
    if (navTo === '/initCorrectCms64Report') {
      _this.props.dispatch(clearCreateCmsTab());
    }

    if (navTo === '/reqInvoicesQtrnotPaid') {
      _this.props.dispatch(refreshInvQtrnotPaidTab());
    }
    if (navTo === '/invoicesforQtrnotPaidDetail') {
      _this.props.dispatch(refreshInvQtrnotPaidTabDisplay());
    }

    if (navTo === '/manufacturerSummary') {
      _this.props.dispatch(refresgManufacturerSummary());
    }
    // if (navTo === '/dispManufacturerSummary') {
    //   _this.props.dispatch(refresgManufacturerSummaryDisplay());
    // }
    if (navTo === '/disputeAmounts') {
      _this.props.dispatch(refreshDisputeAmount({}));
    }
    if (navTo === '/displayManufacturerDisputedAmounts') {
      _this.props.dispatch(refreshDisputeAmountDisplay({}));
    }
    // if (navTo === '/units-claim') {
    //   _this.props.dispatch(clearReduxNumberOfUnitSearchScreen({}));
    // }
    if (navTo === '/excludedClaims') {
      _this.props.dispatch(clearReduxExcludedClaimsSearchScreen());
    }
    if (navTo === '/dispExcludedClaims') {
      _this.props.dispatch(clearReduxExcludedClaimsDetailsScreen());
    }
    if (navTo === '/interestRecieved') {
      _this.props.dispatch(clearReduxInterestRecievedSearchScreen());
    }
    if (navTo === '/interestRecivedDetail') {
      _this.props.dispatch(clearReduxInterestRecievedDetailsScreen());
    }
    if (navTo === '/systemReminders') {
      _this.props.dispatch(clearReduxSystemReminderScreen());
    }
    if (navTo === '/outstandingDisputesForNumOfDays') {
      _this.props.dispatch(
        clearReduxOutStandingDisputesForNumberOfDaysSearchScreen()
      );
    }
    // if (navTo === '/dispOutstandingDisputeNumOfDays') {
    //   _this.props.dispatch(
    //     clearReduxOutStandingDisputesForNumberOfDaysDetailsScreen()
    //   );
    // }
    if (navTo === '/outstandingDisputesForQuarter') {
      _this.props.dispatch(
        clearReduxOutStandingDisputesQuarterOfDaysSearchScreen()
      );
    }
    if (navTo === '/displayOutstandingDisputesForQuarter') {
      _this.props.dispatch(
        clearReduxOutStandingDisputesQuarterOfDaysDetailsScreen()
      );
    }
    if (navTo === '/zeroURA') {
      _this.props.dispatch(clearReduxZeroURASearchScreen());
    }
    if (navTo === '/dispZeroURA') {
      _this.props.dispatch(clearReduxZeroURADetailsScreen());
    }
    if (navTo === '/checkallocationcomparison') {
      _this.props.dispatch(
        clearReduxDataOnCheckAllocationComparisonSearchScr()
      );
    }
    if (navTo === '/checkallocationcomparisiondispaly') {
      _this.props.dispatch(
        clearReduxDataOnCheckAllocationComparisonDetailScr()
      );
    }
    if (navTo === '/underThresholdInvoice') {
      _this.props.dispatch(clearReduxUnderThresholdInvSearchScreen());
    }
    if (navTo === '/quarterlyPayment1') {
      _this.props.dispatch(refreshQuarterlyPayment({}));
    }
    // if (navTo === '/quarterlyPaymentDisplay') {
    //   _this.props.dispatch(refreshQuarterlyPaymentDisplay({}));
    // }
    if (navTo === '/cmsUra') {
      _this.props.dispatch(refreshCMSUroa({}));
    }
    if (navTo === '/displaycmsUra') {
      _this.props.dispatch(refreshCMSUroaDisplay({}));
    }
    if (navTo === '/rebatesummary') {
      _this.props.dispatch(refreshRebateSummary({}));
    }

    if (navTo === '/disputeActivity') {
      _this.props.dispatch(refreshDisputeActivity({}));
    }
    if (navTo === '/displayDisputeActivity') {
      _this.props.dispatch(refreshDisputeActivityDisplay({}));
    }
    if (navTo === '/disputeCodes') {
      _this.props.dispatch(refreshDisputeCode({}));
    }
    if (navTo === '/displayDisputeCodes') {
      _this.props.dispatch(refreshDisputeCodeDisplay({}));
    }
    if (navTo === '/requestURACalculation') {
      _this.props.dispatch(resetReqURLCalcStore({}));
    }
    if (navTo === '/requestInvoiceCalculation') {
      _this.props.dispatch(resetRequestInvoiceCalculationStore({}));
    }
    if (navTo === '/disputeRecapitulation') {
      _this.props.dispatch(refreshDisputeRecap({}));
    }
    if (navTo === '/displayDisputeRecapitulation') {
      _this.props.dispatch(refreshDisputeRecapDisplay({}));
    }
    if (navTo === '/drugTypeSummary') {
      _this.props.dispatch(refreshDrugType({}));
    }
    if (navTo === '/displayDrugTypeSummary') {
      _this.props.dispatch(refreshDrugTypeDisplay({}));
    }
    if (navTo === '/paymentSummary') {
      _this.props.dispatch(refreshPaymentSummary({}));
    }
    if (navTo === '/displaypaymentSummary') {
      _this.props.dispatch(refreshPaymentSummaryDisplay({}));
    }
    if (navTo === '/340BProviderClaims') {
      _this.props.dispatch(refreshBProviderClaims({}));
    }
    if (navTo === '/display340BProviderClaims') {
      _this.props.dispatch(refreshBProviderClaimsDisplay({}));
    }
    if (navTo === '/currentToPreviousQuarterInvoiceComparison') {
      _this.props.dispatch(refreshCurrentToPrevious({}));
    }
    if (navTo === '/displayCurrentToPreviousQuarterInvoiceComparison') {
      _this.props.dispatch(refreshCurrentToPreviousDisplay({}));
    }
    if (navTo === '/quarterlyclaimsreconcilliation') {
      _this.props.dispatch(refreshQuarterlyClaimReconcilliationSate({}));
    }

    if (navTo === '/monthlyclaimsreconcilliation') {
      _this.props.dispatch(refreshMonthlyClaimReconcilliationState({}));
    }

    if (navTo === '/percentSpend') {
      _this.props.dispatch(refreshRebatePercent({}));
    }
    if (navTo === '/maufacturer') {
      _this.props.dispatch(refreshRebatePercentDisplay({}));
    }
    if (navTo === '/adjustmentByReasonCode') {
      _this.props.dispatch(refreshAdjustmentCodeByReason({}));
    }
    // if (navTo === '/dispAdjustmentByReasonCode') {
    //   _this.props.dispatch(refreshReduxAdjustmentByReasonDetailScreen({}));
    // }
    if (navTo === '/unallocatedBalance') {
      _this.props.dispatch(refreshUnallocatedBalance({}));
    }
    if (navTo === '/unallocated-balance-report') {
      _this.props.dispatch(refreshUnallocatedBalanceDispaly({}));
    }

    if (navTo === '/interestRecieved') {
      _this.props.dispatch(refreshInterestRecieved({}));
    }

    if (navTo === '/interestOverride') {
      _this.props.dispatch(refreshInterestOverride({}));
    }
    // if (navTo === '/interestOverrideDetail') {
    //   _this.props.dispatch(refreshInterestOverrideDisplay({}));
    // }
    if (navTo === '/rider') {
      _this.props.dispatch(refreshRider({}));
    }
    if (navTo === '/riderdetails') {
      _this.props.dispatch(refreshRiderDisplay({}));
    }
    if (navTo === '/totaldollarspaid') {
      _this.props.dispatch(refreshTotalDollarsPaid({}));
    }
    if (navTo === '/checkallocationcomparison') {
      _this.props.dispatch(refreshCheckAllocationComparision({}));
    }
    if (navTo === '/terminatedlabeler') {
      _this.props.dispatch(refreshTerminatedLabeler({}));
    }
    // if (navTo === '/terminatedlabelerdisplay') {
    //   _this.props.dispatch(refreshTerminatedLabelerDisplay({}));
    // }
    if (navTo === '/excludedClaims') {
      _this.props.dispatch(refreshExcludedClaims({}));
    }

    if (navTo === '/invoiceRegister') {
      _this.props.dispatch(refreshInvoiceRegister({}));
    }
    if (navTo === '/invoice') {
      _this.props.dispatch(refreshInvoiceRegisterDisplay({}));
    }
    if (navTo === '/chipCshcnRates') {
      _this.props.dispatch(refreshChipCshcnRates({}));
    }
    if (navTo === '/dispChipCshcnReport') {
      //  _this.props.dispatch(refreshChipCshcnRatesDisplay({}));
    }
    if (navTo === '/currentZeroURA') {
      _this.props.dispatch(refreshCurrentZeroURA({}));
    }
    // if (navTo === '/dispCurrentZeroURA') {
    //   _this.props.dispatch(refreshCurrentZeroURADisplay({}));
    // }
    if (navTo === '/cashReceiptSummary') {
      _this.props.dispatch(refreshCashReceiptSummary({}));
    }
    if (navTo === '/dispCashReceiptSummary') {
      _this.props.dispatch(refreshCashReceiptSummaryDisplay({}));
    }
    if (navTo === '/ndcPayment') {
      _this.props.dispatch(refreshNDCPayment({}));
    }
    // if (navTo === '/dispNDCPayment') {
    //   _this.props.dispatch(refreshNDCPaymentDisplay({}));
    // }
    if (navTo === '/institionalClaimsTypeDiscrepancy') {
      _this.props.dispatch(refreshInstitutionalClaimUnitTypeDiscrepancy({}));
    }
    if (navTo === '/dispInstitionalClaimsTypeDiscrepancy') {
      _this.props.dispatch(refreshInstitutionalClaimUnitTypeDiscDetailScreen());
    }
    if (navTo === '/chipCshcnRateAudit') {
      _this.props.dispatch(refreshChipCshcnRateAudit({}));
    }
    if (navTo === '/dispChipCshcnRateAudit') {
      _this.props.dispatch(refreshChipCshcnRateAuditDisplay({}));
    }
    if (navTo === '/zeroURA') {
      _this.props.dispatch(refreshZeroURA({}));
    }
    if (navTo === '/dispZeroURA') {
      _this.props.dispatch(refreshZeroURADisplay({}));
    }
    if (navTo === '/mco_claims') {
      _this.props.dispatch(refreshMcoClaims({}));
    }
    if (navTo === '/display_mco_claims') {
      _this.props.dispatch(refreshMcoClaimsDisplay({}));
    }
    if (navTo === '/familyPlanningDrugsInvoicedforRebates') {
      _this.props.dispatch(refreshFamilyPlanningDrugInv({}));
    }
    if (navTo === '/DisplayFamilyPlanningDrugsInvoicedRebates') {
      _this.props.dispatch(refreshFamilyPlanningDrugInvDisplay({}));
    }
    if (navTo === '/hcpcsCodeClaimsPaid') {
      _this.props.dispatch(refreshHCPCScodeClaims({}));
    }
    if (navTo === '/displayHcpcsCode') {
      _this.props.dispatch(refreshHCPCScodeClaimsDisplay({}));
    }
    if (navTo === '/drugsTherapeuticClass') {
      _this.props.dispatch(refreshDrugsTherapeuticClass({}));
    }

    if (navTo === '/displayDrugsTherapeuticClass') {
      _this.props.dispatch(refreshDisplayDrugsTherapeuticClass({}));
    }
    if (navTo === '/cmsDrug') {
      _this.props.dispatch(refreshCMSDrug({}));
    }
    if (navTo === '/displayCmsDrug') {
      _this.props.dispatch(refreshCMSDrugDisplay({}));
    }
    if (navTo === '/familyPlanningDrugsPaymentReceived') {
      _this.props.dispatch(refreshFamilyPlanningDrugPmtRec({}));
    }
    if (navTo === '/DisplayFamilyPlanningDrugsPmtRec') {
      _this.props.dispatch(refreshFamilyPlanningDrugPmtRecDisplay({}));
    }
    if (navTo === '/outstandingBalanaceByLabererAndQuarter') {
      _this.props.dispatch(refreshOustandingByLabelerAndQtr({}));
    }
    // if (navTo === '/disOutstandingBalanaceByLabererAndQuarter') {
    //   _this.props.dispatch(refreshOustandingByLabelerAndQtrDisplay({}));
    // }
    if (navTo === '/ndcdetails') {
      _this.props.dispatch(refreshNDCDetails({}));
    }
    if (navTo === '/ndcdetailsdisplay') {
      _this.props.dispatch(refreshNDCDetailsDisplay({}));
    }
    if (navTo === '/PreInvoiceUnitAdjustment') {
      // _this.props.dispatch(dispatchPerformResolutionObj({}));
      _this.props.dispatch(refreshPreInvoiceUnitAdujustment({}));
    }
    if (navTo === '/DisplayPreInvoiceUnitAdjustment') {
      // _this.props.dispatch(dispatchPerformResolutionObj({}));
      _this.props.dispatch(refreshPreInvoiceUnitAdujustmentDisplay({}));
    }
    if (navTo === '/ndchistoryreport') {
      _this.props.dispatch(refreshNDCHistory({}));
    }
    if (navTo === '/ndchistorydisplay') {
      _this.props.dispatch(refreshNDCHistoryDisplay({}));
    }
    if (navTo === '/contractreport') {
      _this.props.dispatch(refreshContractReport({}));
    }
    if (navTo === '/activeLabeler') {
      _this.props.dispatch(refreshActiveLabeler({}));
    }
    if (navTo === '/displayActiveLabeler') {
      _this.props.dispatch(refreshActiveLabelerDisplay({}));
    }
    if (navTo === '/cmsReportAdjustmentDetail') {
      _this.props.dispatch(refreshCmsAdjustment({}));
    }
    if (navTo === '/displayCmsReportAdjustmentDetail') {
      _this.props.dispatch(refreshCmsAdjustmentDisplay({}));
    }
    if (navTo === '/CMSQuarterlyReporting') {
      _this.props.dispatch(refreshCMSQuarterlyReporting({}));
    }
    if (navTo === '/DisplayCMSQuarterlyReporting') {
      //   _this.props.dispatch(refreshCMSQuarterlyReportingDisplay({}));
    }
    if (navTo === '/programAndEligibilityCategory') {
      _this.props.dispatch(refreshProgramCategory({}));
    }
    if (navTo === '/displayProgramAndEligibilityCategory') {
      _this.props.dispatch(refreshProgramCategoryDisplay({}));
    }
    if (navTo === '/topBalances') {
      _this.props.dispatch(refreshTopBalances({}));
    }
    if (navTo === '/displaytopbalances') {
      //  _this.props.dispatch(refreshTopBalancesDisplay({}));
    }
    if (navTo === '/rosi_pqas') {
      _this.props.dispatch(refreshRosiPqas({}));
    }
    if (navTo === '/displayrosi_pqas') {
      _this.props.dispatch(refreshRosiPqasDisplay({}));
    }
    if (navTo === '/supplementalRates') {
      _this.props.dispatch(refreshSupplementalRates({}));
    }
    if (navTo === '/displaySupplementalRates') {
      _this.props.dispatch(refreshSupplementalRatesDisplay({}));
    }
    if (navTo === '/adjustedClaims') {
      _this.props.dispatch(refreshNDCDetailsAdjusted({}));
    }
    if (navTo === '/unitAdjustmentatNdcLevel') {
      _this.props.dispatch(refreshUnitAdjustment({}));
    }
    if (navTo === '/displayUnitAdjustmentatNdcLevel') {
      _this.props.dispatch(dispatchDisplayUnitAdjustment({}));
    }
    if (navTo === '/providerClaimListing') {
      _this.props.dispatch(refreshDProviderClaim({}));
    }
    if (navTo === '/displayProviderClaimListing') {
      _this.props.dispatch(refreshDProviderClaimDisplay({}));
    }
    if (navTo === '/substanceAbuseDrug') {
      _this.props.dispatch(refreshSubstanceAbuse({}));
    }
    if (navTo === '/displaSubstanceAbuseDrug') {
      _this.props.dispatch(refreshSubstanceAbuseDisplay({}));
    }
    if (navTo === '/manufacturerOutstandingBalance') {
      _this.props.dispatch(refreshMfgOustandingBalance({}));
    }
    if (navTo === '/displayManufacturerOutstandingBalance') {
      //  _this.props.dispatch(refreshMfgOustandingBalanceDisplay({}));
    }
    if (navTo === '/claimGroupingParameter') {
      _this.props.dispatch(resetRequestCGPStore({}));
    }
    if (navTo === '/ura-search') {
      _this.props.dispatch(resetURASearchStore({}));
    }
    if (navTo === '/selected-ura') {
      _this.props.dispatch(resetURADetailStore({}));
    }
    if (navTo === '/rebatePriceSearch') {
      _this.props.dispatch(storePriceLevelErrors([]));
      _this.props.dispatch(
        storePriceSearchInputData({
          rebateProgram: '-1',
          planType: 'COMM',
          drugFamily: 'all',
          quarter: generateQuarter(),
          manufacturerGrid: [],
          mfgId: '',
          familySeq: '',
        })
      );
      _this.props.dispatch(dispatchManufacturerList(false));
      _this.props.dispatch(dispatchAllDrugFamilies({}));
      _this.props.dispatch(clearReduxforRebatePriceSearch({}));
    }
    if (navTo === '/rebatePriceDetails') {
      _this.props.dispatch(dispatchMaintanancePriceDetails([]));
      _this.props.dispatch(storeUpdatedDetailsPage({}));
      _this.props.dispatch(storePriceDetailsErrors([]));
      //  _this.props.dispatch(onChangePage(false));
      _this.props.dispatch(dispatchMaintanancePriceGridDetails({}));
      _this.props.dispatch(clearReduxforRebatePriceDetails({}));
    }

    if (navTo === '/letterTemplate') {
      _this.props.dispatch(
        setRemoveLetterTemplateExtraState({
          createBtn: false,
          coverErr: false,
        })
      );
      _this.props.dispatch(
        removeLetterTemplateErrorMsgList({
          searchPage: [],
        })
      );
    }
  }

  render() {
    const tabItemsData =
      JSON.parse(localStorage.getItem('tabItemsData')) == null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    const tabItemsDataToShow = tabItemsData.filter(
      (value, index, self) =>
        index ===
        self.findIndex(
          (t) => t.navTo === value.navTo && t.value === value.value
        )
    );
    const { uuid } = this.props;
    const { scrollbar, marginRightValue, minHeight, mainFrameRef } = this.state;

    return (
      <div
        className="main-content has-scrollbar container-fluid"
        id="mainContent"
        style={{ marginRight: scrollbar ? 0 : marginRightValue }}
      >
        <div ref={mainFrameRef} style={{ height: '100%' }}>
          <div className="container-fluid">
            <div className="row" id="mainContentHeader">
              <div className="col-12">
                <nav className="navbar navbar-light bg-light navTabs">
                  <form className="form-inline">
                    {tabItemsDataToShow.map((item, index) => (
                      <button
                        tabIndex={-1}
                        key={`navigation-item-${index}`}
                        className={
                          window.location.pathname === item.navTo
                            ? 'btn btn-sm btn-outline-secondary nav-tabs nav-item-active tab-btn-round'
                            : item.isFormError
                            ? 'btn btn-sm btn-outline-secondary nav-tabs nav-item tab-btn-round frr-nav-error'
                            : 'btn btn-sm btn-outline-secondary nav-tabs nav-item tab-btn-round'
                        }
                        type="button"
                      >
                        <NavLink
                          className={
                            window.location.pathname === item.navTo
                              ? 'nav-item-active'
                              : 'nav-item'
                          }
                          to={{
                            pathname:
                              item && item.navTo && item.navTo.length > 0
                                ? item.navTo
                                : '/',
                            value: item,
                            isFormDirty: item.isFormDirty,
                            isFormSave: item.isFormSave,
                            isFormError: item.isFormError,
                            isRefresh: item.isRefresh,
                          }}
                          tabIndex="0"
                        >
                          <span className="tab-title">
                            {item.navTo === '/manufacturer'
                              ? NavigationConstants.SEARCH_MANUFACTURER
                              : item.navTo === '/reqAccReceivable'
                              ? NavigationConstants.ACC_RECEIVABLE
                              : item.navTo === '/tBill'
                              ? NavigationConstants.TBILL_RATES
                              : item.navTo === '/initCorrectCms64Report'
                              ? NavigationConstants.INIT_CMS64_REPORTS
                              : item.navTo === '/excludedNDCs'
                              ? NavigationConstants.SEARCH_EXCLUDED_NDCS
                              : item.navTo === '/check' ||
                                item.navTo === '/checks'
                              ? NavigationConstants.SEARCH_CHECK
                              : item.navTo === '/logBatchSearch'
                              ? NavigationConstants.LOG_BATCH_TOTAL
                              : item.navTo === '/comment'
                              ? NavigationConstants.COMMENT_AND_CORRESPONDENCE
                              : item.navTo === '/checksByInvoice'
                              ? NavigationConstants.CHECKS_BY_INVOICE
                              : item.navTo === '/assignDisputesSearch'
                              ? NavigationConstants.ASSIGN_DISPUTE_SEARCH
                              : item.navTo === '/unitConversion'
                              ? NavigationConstants.UNIT_CONVERSION
                              : item.navTo === '/labelerDifferences'
                              ? NavigationConstants.LABELER_DIFF
                              : item.navTo === '/invoiceAudits'
                              ? NavigationConstants.INVOICE_AUDITS_SEARCH
                              : item.navTo === '/contract'
                              ? NavigationConstants.SEARCH_CONTRACT
                              : item.navTo === '/cmsMismatch'
                              ? NavigationConstants.CMS_MISMATCH
                              : item.navTo === '/cmsRosi'
                              ? NavigationConstants.CMS_ROSI
                              : item.navTo === '/contactAnomalies'
                              ? NavigationConstants.CONTACT_ANOMALIES
                              : item.navTo === '/claimAuditSelect'
                              ? NavigationConstants.CLAIM_AUDIT_SELECT
                              : item.navTo === '/cmsDrugFileDiscrepancies'
                              ? NavigationConstants.CMS_DRUG_FILE
                              : item.navTo === '/cmsDrugFileDetail'
                              ? NavigationConstants.CMS_DRUG_FILE_DETAIL
                              : item.navTo === '/disputes'
                              ? NavigationConstants.MANUFACTURER_DISPUTES
                              : item.navTo === '/rosiInconsistencies'
                              ? NavigationConstants.ROSI_PQAS_INCONSISTENCIES
                              : item.navTo === '/systemparameter'
                              ? NavigationConstants.SYSTEM_PARAMETER
                              : item.navTo === '/searchViewCheckAllocation'
                              ? NavigationConstants.SEARCH_CHECK
                              : item.navTo === '/underThresholdInvoice'
                              ? NavigationConstants.UNDER_THRESHOLD_INVOICE
                              : item.navTo === '/letter'
                              ? NavigationConstants.REQUEST_DISPLAY_LETTER
                              : item.navTo === '/ura-search'
                              ? NavigationConstants.URA_SEARCH
                              : item.navTo === '/requestCurrentDisputeDisplay'
                              ? NavigationConstants.REQUEST_CURRENT_DISPUTE_DISPLAY
                              : item.navTo === '/generateInvoice'
                              ? NavigationConstants.GENERATE_INVOICES
                              : item.navTo === '/SearchRebate'
                              ? NavigationConstants.REBATE_PROGRAM
                              : item.navTo === '/accReceivable'
                              ? NavigationConstants.ACC_RECEIVABLE
                              : item.navTo === '/priceLevel'
                              ? NavigationConstants.REBATE_PRICE_LEVEL
                              : item.navTo === '/providerReview'
                              ? NavigationConstants.RECORD_PROVIDER_REVIEW
                              : item.navTo === '/rebatePriceSearch'
                              ? NavigationConstants.REBATE_PRICE_SEARCH
                              : item.navTo === '/rebatePriceDetails'
                              ? NavigationConstants.MAUNTAIN_REBATE_PRICE
                              : item.navTo === '/quarterlyPayment1'
                              ? NavigationConstants.REQUEST_QUARTERLY_PAYMENT
                              : item.navTo === '/reqInvoicesQtrnotPaid'
                              ? NavigationConstants.REQUEST_INVOICES_QTR_NOT_PAID
                              : item.navTo === '/allocatePayment'
                              ? NavigationConstants.ALLOCATE_PAYMENTS
                              : item.navTo === '/percentSpend'
                              ? NavigationConstants.REBATE_PERCENT_SPEND
                              : item.navTo === '/invoiceRegister'
                              ? NavigationConstants.INVOICE_REGISTER
                              : item.navTo === '/paymentSummary'
                              ? NavigationConstants.PAYMENT_SUMMARY
                              : item.navTo === '/topBalances'
                              ? NavigationConstants.TOP_BALANCES
                              : item.navTo === '/unallocatedBalance'
                              ? NavigationConstants.UNALLOCATED_BALANCE
                              : item.navTo === '/checkallocationcomparison'
                              ? NavigationConstants.CHECK_ALLOCATION_COMPARISON
                              : item.navTo === '/interestOverride'
                              ? NavigationConstants.INTEREST_OVERRIDE
                              : item.navTo === '/disputeAmounts'
                              ? NavigationConstants.DISPUTE_AMOUNT
                              : item.navTo === '/interestRecieved'
                              ? NavigationConstants.INTEREST_RECIEVED
                              : item.navTo === '/ndcdetails'
                              ? NavigationConstants.NDC_DETAILS
                              : item.navTo === '/disputeActivity'
                              ? NavigationConstants.DISPUTE_ACTIVITY
                              : item.navTo === '/currentZeroURA'
                              ? NavigationConstants.CURRENT_ZERO_URA
                              : item.navTo === '/hcpcsCodeClaimsPaid'
                              ? NavigationConstants.HCPCS_CODE_CLAIMS_PAID
                              : item.navTo === '/ndcDetails'
                              ? NavigationConstants.NDC_DETAILS
                              : item.navTo === '/ndchistoryreport'
                              ? NavigationConstants.NDC_HISTORY
                              : item.navTo === '/zeroURA'
                              ? NavigationConstants.ZERO_URA
                              : item.navTo ===
                                '/outstandingDisputesForNumOfDays'
                              ? NavigationConstants.OUTSTANDING_DISPUTES_NUM_DAYS
                              : item.navTo === '/outstandingDisputesForQuarter'
                              ? NavigationConstants.OUTSTANDING_DISPUTES_QUARTER
                              : item.navTo === '/PreInvoiceUnitAdjustment'
                              ? NavigationConstants.REQUEST_PREINVOICE_ADJUSTMENT
                              : item.navTo === '/mco_claims'
                              ? NavigationConstants.MCO_CLAIMS
                              : item.navTo === '/adjustmentByReasonCode'
                              ? NavigationConstants.ADJUSTMENT_REASON_CODE
                              : item.navTo ===
                                '/institionalClaimsTypeDiscrepancy'
                              ? NavigationConstants.INSTITUTIONAL_CLAIMS_TYPE_DISCREPANCY
                              : item.navTo === '/cmsDrug'
                              ? NavigationConstants.REQUEST_QUARTERLY_CMS_DRUG
                              : item.navTo === '/programAndEligibilityCategory'
                              ? NavigationConstants.REQUEST_PROGRAM_ELIGIBILTY
                              : item.navTo ===
                                '/currentToPreviousQuarterInvoiceComparison'
                              ? NavigationConstants.REQUEST_CURRENT_TO_PREVIOUS
                              : item.navTo === '/cashReceiptSummary'
                              ? NavigationConstants.REQUEST_CASH_RECEIPT_SUMMARY
                              : item.navTo === '/manufacturerSummary'
                              ? NavigationConstants.REQUEST_MANUFACTURER_SUMMARY
                              : item.navTo === '/disputeCodes'
                              ? NavigationConstants.REQUEST_DISPUTE_CODE
                              : item.navTo === '/cmsReportAdjustmentDetail'
                              ? NavigationConstants.REQUEST_ADJUSTMENT_DETAIL
                              : item.navTo ===
                                '/outstandingBalanaceByLabererAndQuarter'
                              ? NavigationConstants.REQUEST_OUTSTANDING_BALANCE_BY_LABERER_AND_QUARTER
                              : item.navTo === '/adjustedClaims'
                              ? NavigationConstants.REQUEST_ADJUSTED_CLAIMS
                              : item.navTo ===
                                '/familyPlanningDrugsInvoicedforRebates'
                              ? NavigationConstants.REQUEST_FAMILY_PLANNING_DRUGS_INVOICED_FOR_REBATES
                              : item.navTo ===
                                '/familyPlanningDrugsPaymentReceived'
                              ? NavigationConstants.REQUEST_FAMILY_PLANNING_DRUGS_PAYMENT_RECEIVED
                              : item.navTo === '/ndcPayment'
                              ? NavigationConstants.NDC_PAYMENT_RPT
                              : item.navTo === '/excludedClaims'
                              ? NavigationConstants.EXCLUDED_CLAIMS_RPT
                              : item.navTo === '/chipCshcnRates'
                              ? NavigationConstants.CHIP_CSHCN_RPT
                              : item.navTo === '/terminatedlabeler'
                              ? NavigationConstants.TERMINATED_LABELER
                              : item.navTo === '/activeLabeler'
                              ? NavigationConstants.REQUEST_ACTIVE_LABELER
                              : item.navTo === '/drugsTherapeuticClass'
                              ? NavigationConstants.REQUEST_DRUGS_THERAPEUTIC_CLASS
                              : item.navTo === '/chipCshcnRateAudit'
                              ? NavigationConstants.CHIP_CSHCN_RATE_AUDIT_RPT
                              : item.navTo === '/supplementalRates'
                              ? NavigationConstants.SUPPLEMENTAL_RATES
                              : item.navTo === '/unitAdjustmentatNdcLevel'
                              ? NavigationConstants.UNIT_ADJUSTMENT
                              : item.navTo ===
                                '/manufacturerOutstandingBalanace'
                              ? NavigationConstants.REQUEST_MANUFACTURER_OUTSTANDING_BALANCE
                              : item.navTo === '/substanceAbuseDrug'
                              ? NavigationConstants.SUBSTANCE_ABUSE
                              : item.navTo === '/providerClaimListing'
                              ? NavigationConstants.PROVIDER_CLAIM
                              : item.navTo === '/CMSQuarterlyReporting'
                              ? NavigationConstants.CMS_QUARTERLY_REPORTING
                              : item.navTo === '/reminderRecipients'
                              ? NavigationConstants.REMINDER_RECIPIENT
                              : item.navTo === '/requestDataNicheReport'
                              ? NavigationConstants.DATA_NICHE_REPORT
                              : item.navTo === '/maintainIneligibleCPT'
                              ? NavigationConstants.INELIGIBLE_CPT
                              : item && item.value}
                          </span>{' '}
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              this.closeTab(
                                e,
                                item && item.value,
                                item.navTo,
                                item.state
                              );
                            }}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter') {
                                e.stopPropagation();
                                e.preventDefault();
                                this.closeTab(
                                  e,
                                  item && item.value,
                                  item.navTo,
                                  item.state
                                );
                              }
                            }}
                            title="Click Enter to close the tab"
                            tabIndex={0}
                            className="close-tab"
                          >
                            <SVGComponent iconName="Icon-cancel" />
                          </span>
                        </NavLink>
                      </button>
                    ))}
                    {tabItemsDataToShow.length > 0 && (
                      <span title="Reducing the screen size or resolution to 90%, 80%, or lower allows for the accommodation of additional tabs.">
                        <SVGComponent iconName="Icon-info" />
                      </span>
                    )}
                  </form>
                </nav>{' '}
              </div>
            </div>

            <div
              className="row main-content-wrapper"
              style={{ minHeight: minHeight }}
            >
              <div className="col-12">
                <ErrorHandler element="MainFrame">
                  <SessionExpire />
                  <Route>
                    <Routes uuid={uuid} />
                  </Route>
                </ErrorHandler>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(App);
